import obbaMainImage from "../src/image/project-obba/project-obba.png";
import obbaLFD from "../src/image/project-obba/obba-low-fidelity.png";
import obbaMFD from "../src/image/project-obba/obba-mid-fidelity.png";
import obbaHFD from "../src/image/project-obba/obba-high-fidelity.png";
import obbaSwiperJs from "../src/image/project-obba/swiper-js.png";
import obbaNavMenu from "../src/image/project-obba/obba-navmenu.gif";
import obbaFormSubmit from "../src/image/project-obba/obba-formsubmit.png";
import obbaHostinger from "../src/image/project-obba/obba-hostinger.png";

import singmateMainImage from "../src/image/project-singmate/project-singmates.png";
import singmateWebsiteLayout from "../src/image/project-singmate/website-layout.png";
import singmateWebsiteLayoutModified from "../src/image/project-singmate/website-layout-modified.png";
import fileStructure from "../src/image/project-singmate/file-structure.png";
import fileStructure2 from "../src/image/project-singmate/file-structure-2.png";
import singmateNavMenu from "../src/image/project-singmate/singmate-navmenu.gif";
import singmateMobile from "../src/image/project-singmate/singmate-mobile.png";
import singmateBanners from "../src/image/project-singmate/website-banner.png";

import alomaloMainImage from "../src/image/project-alomalo/project-alomalo.png";
import alomaloDesignRef1 from "../src/image/project-alomalo/design-ref-1.png";
import alomaloDesignRef2 from "../src/image/project-alomalo/design-ref-2.png";
import alomaloLFD from "../src/image/project-alomalo/design-layout.png";
import alomaloHFD from "../src/image/project-alomalo/design-layout-2.png";
import alomaloCollapse from "../src/image/project-alomalo/collapse-design.gif";

import onstampMainImage from "../src/image/project-onstamp/project-onstamp.png";
import onstampEx1 from "../src/image/project-onstamp/ex-1.png";
import onstampEx2 from "../src/image/project-onstamp/ex-2.png";
import onstampAndroidIos from "../src/image/project-onstamp/iosandroid.png";
import rnThumb from "../src/image/project-onstamp/rn-thumb.png";
import onstampLFD from "../src/image/project-onstamp/onstamp-lfd.jpeg";
import onstampLFD2 from "../src/image/project-onstamp/onstamp-lfd-2.jpeg";
import onstampDesign from "../src/image/project-onstamp/project-design.png";
import firebaseThumb from "../src/image/project-onstamp/firebase-thumb.png";
import onstampFS from "../src/image/project-onstamp/onstamp-filestructure.png";
import onstampFS2 from "../src/image/project-onstamp/onstamp-filestructure-2.png";
import onstampFS3 from "../src/image/project-onstamp/onstamp-filestructure-3.png";
import otp1 from "../src/image/project-onstamp/otp1.gif";
import otp2 from "../src/image/project-onstamp/otp2.gif";
import otp3 from "../src/image/project-onstamp/otp3.gif";
import stampScreen from "../src/image/project-onstamp/stamp-screen.png";
import stamp1 from "../src/image/project-onstamp/stamp1.gif";
import stamp2 from "../src/image/project-onstamp/stamp2.gif";
import stamp3 from "../src/image/project-onstamp/stamp3.gif";
import onstampDb from "../src/image/project-onstamp/firestore-1.png";

import gogosingMainImage from "../src/image/project-gogosing/project-1.png";
import gogosingEx1 from "../src/image/project-gogosing/gogosing-ex-1.png";
import gogosingEx2 from "../src/image/project-gogosing/gogosing-ex-2.png";
import karrot from "../src/image/project-gogosing/karrot.png";
import gogosingDesign from "../src/image/project-gogosing/gogosing-design.png";
import gogosingHome from "../src/image/project-gogosing/gogosing-home.png";
import gogosingMarket from "../src/image/project-gogosing/gogosing-market.png";
import gogosingReview1 from "../src/image/project-gogosing/gogosing-review-1.png";
import gogosingReview2 from "../src/image/project-gogosing/gogosing-review-2.png";
import gogosingReviewDM from "../src/image/project-gogosing/gogosing-review-dm.png";
import gogosingCoupon1 from "../src/image/project-gogosing/gogosing-coupon-1.png";
import gogosingCoupon2 from "../src/image/project-gogosing/gogosing-coupon-2.png";
import gogosingPagination from "../src/image/project-gogosing/gogosing-pagination.gif";
import gogosingCompositeI from "../src/image/project-gogosing/gogosing-composite-index.png";

import jsOptionalMain from "../src/image/blog-posts/post1/js-optional-main.png";
import jsOptional1 from "../src/image/blog-posts/post1/js-optional-1.jpeg";
import reacthookMain from "../src/image/blog-posts/post2/react-hooks.png";
import rnNavigationMain from "../src/image/blog-posts/post3/rn-navigation-main.png";
import rnFlatlistMain from "../src/image/blog-posts/post4/rn-flatlist-main.png";
import reduxToolkitMain from "../src/image/blog-posts/post5/redux-toolkit-main.jpeg";

/*
{
        section_title: "",
        section_subtitle: "",
        section_image: "",
        section_mobile: "",
        section_content: "",
        section_bullets: "",
        section_codes: "",
      },
*/

export const projectData = [
  {
    id: 1,
    title: "GOGOSING",
    date: "11 November 2023",
    main_image: gogosingMainImage,
    subtitle:
      "Social platform mobile application to facilitate communication and the buying and selling of new and secondhand goods within the Korean community in Singapore",
    sections: [
      {
        section_title: "Ideation",
        section_subtitle: "Background",
        section_content:
          "As of 2022, there are about 21,400 South Korean residents in Singapore. The formation of communities among foreigners from the same country in a new land is a natural response to the human need for connection, support, and a sense of belonging, especially in the face of the challenges posed by living in a different cultural context. It often leads to the creation of community platform such as website and mobile application these days. Good examples of such community platforms for Korean residents in Singapore are HanKookChon and YellowSing.",
      },
      {
        section_image: gogosingEx1,
      },
      {
        section_image: gogosingEx2,
        section_content:
          "In the case of HanKookChon, it is the oldest and largest Korean community website in Singapore. The main features of the website are business advertisement, buying, selling and sharing of goods, job search and community interaction. Recently, they also released mobile application as well.",
      },
      {
        section_content:
          "Similarly, YellowSing, which started as a simple phone book mobile application, has grown into a mobile application that is now used as a marketing tool for Korean business owners in Singapore and allows Korean residents to easily access various events and promotional information. ",
      },
      {
        section_content:
          "However, there have been not many new competitors for nearly decade, these two platforms have dominated the Korean community market without much innovative developments. The reason why I call it ‘market’ because although it is a small Korean community of about 21,000 people here in Singapore, many Korean businesses are carried out through these two platforms, and companies operating these two platforms make profits.",
      },
      {
        section_content:
          "There were many reasons for me to think about and start this project, but the biggest reason among them was that I met and talked to lot of Korean residents for the past 15 years, but most of them are using them with one common reason - there is no other alternative.",
      },
      {
        section_content:
          "In fact, when I met and talked with Korean business owners in Singapore, they had no other options to pay for advertisements for their businesses targeting Koreans. The biggest complaint was that although many improvement points were found, there was no significant change when these feedbacks were delivered.",
      },
      {
        section_subtitle: "Motivation",
        section_mobile: karrot,
        section_content:
          "With the background mentioned earlier in this post, I thought that I wanted to improve problems by building a community platform like Karrot in South Korea. Karrot is a community-driven super app from Korea that is committed to nurturing local interactions. They offer a wide range of services, including buying and selling goods, community groups, job listings, real estate and auto listings, and payment solutions. They already have over 30 million users in South Korea. Compared to the size of users they are handling, the size of 21,000 was thought to be a good condition to try out a similar business model of Karrot. ",
      },
      {
        section_title: "Design",
        section_content:
          "Unlike other project I have participated, I really wanted to build this platform as a team - regardless of the team size. The reason was simple. Most of the previous projects were small and considering the cost of the project, it was inefficient to put additional manpower for design. So, even though design part was not my major but I had to design, plan and develop everything myself using a tool like Figma. However, it was very time-consuming and above all, I wanted to focus only on ‘development’ this time.",
      },
      {
        section_content:
          "For the design part of this project, a friend of mine, Raymond, who currently works as a product designer, showed great interest in this project. After having many conversations with him, he decided to take full charge of the design parts.",
      },
      {
        section_image: gogosingDesign,
        section_content:
          "Unlike other solo projects, design work could be improved iteratively based on the feedbacks considering both designer’s perspective and developer’s perspective. ",
      },
      {
        section_subtitle: "Key Features of The Application",
        section_content: "The key features of GOGOSING are as follow:",
        section_bullets: [
          "Allows users to easily access information on various Korean businesses operating in Singapore.",
          "User review feature - feedback for business owners and enhance consumer decision-making.",
          "Community interaction for selling and buying of goods, job listings, and Q&A on a range of topics that may arise during stay in Singapore.",
          "Marketing advertisement feature for business owners, making it faster and easier to provide promotional event information to customers. ",
          "Various digital coupons for users to enjoy more benefits during their visit.",
        ],
      },
      {
        section_title: "Development",
        section_image: rnThumb,
      },
      {
        section_image: firebaseThumb,
        section_content:
          "With the experience of building ONSTAMP and the learning from the project, GOGOSING was also carried out using React Native and Firebase for the frontend and backend. Since at the time of writing this post, the project is still ongoing, I will describe and explain the features that have been successfully implemented and update the post in the future.",
      },
      {
        section_content:
          "From Firebase, Firebase Authentication is used for user authentication, data storage is done with Firebase Firestore and Firebase Storage stores the image files uploaded",
      },
      {
        section_subtitle: "Screen Navigation",
        section_mobile: gogosingHome,
        section_content:
          "From ‘@react-navigation/native’, Stack and Bottom Tabs were imported and used to organise the application flow and structure. ",
        section_codes: `const Stack = createStackNavigator();
const BottomTabs = createBottomTabNavigator();
const CommunityStack = createStackNavigator();

const HomeStack = () => {
  return (
    <Stack.Navigator screenOptions={{headerShown: false}}>
      <Stack.Screen name={Routes.MAIN_TABS} component={MainTabs} />

      <Stack.Screen name={Routes.SEARCH} component={SearchScreen} />
      <Stack.Screen
        name={Routes.RESTAURANT_DETAIL}
        component={RestaurantDetailScreen}
      />
      <Stack.Screen name={Routes.SIGNIN} component={SignInScreen} />
      <Stack.Screen name={Routes.OTP} component={OTPScreen} />
      <Stack.Screen name={Routes.SIGNUP} component={SignUpScreen} />
      <Stack.Screen
        name={Routes.SIGNUPCOMPLETE}
        component={SignUpCompleteScreen}
      />
      <Stack.Screen
        name={Routes.CHANGEPHONENUMBER}
        component={ChangePhoneNumberScreen}
      />
      <Stack.Screen name={Routes.REVIEW_POST} component={ReviewPostScreen} />
    </Stack.Navigator>
  );
};

const CommunityScreens = () => (
  <CommunityStack.Navigator screenOptions={{headerShown: false}}>
    <CommunityStack.Screen
      name={Routes.MARKET}
      component={MarketScreen}
      options={{animationEnabled: false}}
    />
    <CommunityStack.Screen
      name={Routes.JOB}
      component={JobScreen}
      options={{animationEnabled: false}}
    />
    <CommunityStack.Screen
      name={Routes.PROPERTY}
      component={PropertyScreen}
      options={{animationEnabled: false}}
    />
    <CommunityStack.Screen
      name={Routes.COMMUNITYPOST}
      component={CommunityPostScreen}
    />
    <CommunityStack.Screen
      name={Routes.POST_DETAIL}
      component={PostDetailScreen}
    />
  </CommunityStack.Navigator>
);

const MainTabs = () => {
  return (
    <BottomTabs.Navigator
      initialRouteName={Routes.GOGOSING_MAIN}
      screenOptions={{
        headerShown: false,
        tabBarActiveTintColor: colors.primary_color,
        tabBarStyle: {
          backgroundColor: '#fff',
          height: 75,
          paddingTop: 10,
          paddingBottom: 24,
        },
      }}>
      <BottomTabs.Screen
        name={Routes.GOGOSING_MAIN}
        component={GogosingMainScreen}
        options={{
          tabBarIcon: ({color, size}) => (
            <Home width={size} height={size} stroke={color} />
          ),
          tabBarLabel: '고고싱',
        }}
      />
      <BottomTabs.Screen
        name={Routes.COMMUNITY}
        component={CommunityScreens}
        options={{
          tabBarIcon: ({color, size}) => (
            <Users width={size} height={size} stroke={color} />
          ),
          tabBarLabel: '커뮤니티',
        }}
      />
      <BottomTabs.Screen
        name={Routes.PROMOTIONS_MAIN}
        component={PromotionsMainScreen}
        options={{
          tabBarIcon: ({color, size}) => (
            <Gift width={size} height={size} stroke={color} />
          ),
          tabBarLabel: '프로모션',
        }}
      />
      <BottomTabs.Screen
        name={Routes.STORES_MAIN}
        component={StoresMainScreen}
        options={{
          tabBarIcon: ({color, size}) => (
            <Book width={size} height={size} stroke={color} />
          ),
          tabBarLabel: '한인업소',
        }}
      />
      <BottomTabs.Screen
        name={Routes.VOUCHERS_MAIN}
        component={VouchersMainScreen}
        options={{
          tabBarIcon: ({color, size}) => (
            <Inbox width={size} height={size} stroke={color} />
          ),
          tabBarLabel: '쿠폰함',
        }}
      />
    </BottomTabs.Navigator>
  );
};

export default HomeStack;`,
      },
      {
        section_mobile: gogosingMarket,
        section_content:
          "5 main menu, Home, Community, Promotion, Stores and Coupon were created with BottomTabNavigator and this was attached to the HomeStack. For the community menu and screens, they were separated as another screen stack and attached to the HomeStack as well. Community Stack will contain 3 main screens - market, job opening and real estate, including posting and detail screen. ",
      },
      {
        section_subtitle: "User Review",
        section_mobile: gogosingReview1,
      },
      {
        section_mobile: gogosingReview2,
        section_codes: `export const postReview = (reviewData, selectedImages) => {
  return async dispatch => {
    try {
      const reviewsCollection = firestore().collection('reviews');

      const reviewDocumentRef = await reviewsCollection.add(reviewData);
      const reviewDocumentUid = reviewDocumentRef.id;

      const imageUrls = [];
      const storagePaths = [];

      if (!selectedImages) {
        // Handle the case where selectedImages is undefined or null
        return;
      }

      for (const image of selectedImages) {
        if (image?.assets?.[0]) {
          try {
            const asset = image.assets[0];
            const reference = await storage().ref(
              \`/reviews/\${reviewDocumentUid}/\${asset.fileName}\`,
            );

            if (Platform.OS === 'android') {
              // Upload from base64 data on Android
              await reference.putString(asset.base64, 'base64', {
                contentType: asset.type,
              });
            } else {
              // Upload from file URI on iOS
              await reference.putFile(asset.uri);
            }
            storagePaths.push(
              \`/reviews/\${reviewDocumentUid}/\${asset.fileName}\`,
            );
            const imageUrl = await reference.getDownloadURL();
            imageUrls.push(imageUrl);
          } catch (error) {
            console.log('Error uploading image:', error);
            // Handle the error as needed, e.g., log it or dispatch an action
            // dispatch({ type: 'UPLOAD_IMAGE_FAILURE', error: error.message });
          }
        }
      }

      await reviewDocumentRef.update({images: storagePaths});

      console.log('Uploaded image URLs:', imageUrls);
    } catch (error) {
      console.error('Error posting review:', error);
      // Handle the error as needed, e.g., log it or dispatch an action
      // dispatch({ type: 'REVIEW_POST_FAILURE', error: error.message });
    }
  };
};`,
      },
      {
        section_image: gogosingReviewDM,
        section_content:
          "User review posted will be stored in the Firestore collection ‘reviews’. The structure of each review document will contain the fields seen in the screenshot above. For the images uploaded in their review, they will be stored in the Firebase Storage. The file path for each review will be stored in the Firestore review document. When fetching each review with the fetchReviews function I created, the file path will be used to download the image URL.",
        section_codes: `export const fetchReviews = async (restaurantId, callback) => {
  const query = firestore()
    .collection('reviews')
    .where('restaurant_id', '==', restaurantId)
    .orderBy('createdAt', 'desc');

  const unsubscribe = query.onSnapshot(async querySnapshot => {
    const reviews = [];

    for (const doc of querySnapshot.docs) {
      const data = doc.data();

      if (data.images) {
        const reviewImageUrls = await Promise.all(
          data.images.map(async image => {
            try {
              const imageRef = storage().ref(image);
              return imageRef.getDownloadURL();
            } catch (error) {
              const defaultLogoRef = storage().ref('/default_logo.png');
              return defaultLogoRef.getDownloadURL();
            }
          }),
        );

        data.images = reviewImageUrls;
      }
      reviews.push(data);
    }

    callback(reviews);
  });

  return unsubscribe;
};`,
      },
      {
        section_content:
          "When user selects a store from the Home screen and navigates to the detail screen, all the reviews from the different users will be fetched and rendered. When I first implemented this, the problem I encountered was that the new review posted would not immediately fetched from Firebase. This was because fetchReviews function was invoked in the useEffect hook in the detail screen. useEffect hook only re-renders the screen when there is a change in the component. However, the change in the backend - Firebase Firestore collection and document, would not automatically alert the status change to the frontend. So, to see the new review posted, user had to navigate back to the home screen and trigger the re-rendering of the detail screen. To handle this, I needed real-time listener that can detect the change in the backend. This could be done with onSnapshot method. onSnapshot method allows you to listen for real-time updates to a query or a document. It is commonly used when you want to receive automatic updates whenever the data in your Firestore database changes. ",
      },
      {
        section_content:
          "Similar approach was taken for user rating and community posting.",
      },
      {
        section_subtitle: "User Authentication Flow",
        section_mobile: gogosingCoupon1,
      },
      {
        section_mobile: gogosingCoupon2,
        section_content:
          "I had to consider the user experience the most in this project. From the business perspective, if I force user to sign up for the platform and can guarantee the increase of the number of user, it will be the best option. However, to make GOGOSING competitive against other two platforms and to prevent new user from installing the application and leaving immediately upon seeing the onboarding screen, I made unauthenticated user to enter the home screen first. I thought giving them reasons to continue using the application was more important.",
      },
      {
        section_content:
          "So, I limited the access to the coupon menu, review posting and community posting so that unauthenticated user will sign up for benefits. By giving them the number of available coupons in the application, user will be motivated to signup for the application. Also, I made review and community posting available to only authenticated users. This allows unauthenticated user to access business information and posts in the community menu freely with minimum interruption to their user experience. ",
      },
      {
        section_subtitle: "Pagination for Reviews and Community Posts",
        section_image: gogosingPagination,
        section_content:
          "Any project or business cannot help but consider the server costs. The expected user size is 21,000 at maximum for GOGOSING but how many new posts and reviews will be created cannot be accurately calculated. So, at the testing process for fetching data from Firebase, there are only 20 to 25 posts and reviews but I had to prepare for the case when the size of data increases to 10,000, 1,000,000 or more. ",
        section_codes: `export const fetchMarketPosts = async (collectionId, limit, lastDoc) => {
  try {
    let query = firestore()
      .collection(collectionId)
      .limit(limit)
      .orderBy('createdAt', 'desc');

    if (lastDoc) {
      query = query.startAfter(lastDoc);
    }

    const querySnapshot = await query.get();
    let marketPosts = [];

    for (const doc of querySnapshot.docs) {
      const data = doc.data();

      if (data.images) {
        const postImageUrls = await Promise.all(
          data.images.map(async image => {
            try {
              const imageRef = storage().ref(image);
              return imageRef.getDownloadURL();
            } catch (error) {
              const defaultLogoRef = storage().ref('/default_logo.png');
              return defaultLogoRef.getDownloadURL();
            }
          }),
        );

        data.images = postImageUrls;
      }

      marketPosts.push(data);
    }

    const newLastDoc = querySnapshot.docs[querySnapshot.docs.length - 1];

    return {marketPosts, lastDoc: newLastDoc};
  } catch (error) {
    console.log(error);
  }
};`,
      },
      {
        section_codes: `// Load more data when reaching the end of the list
  const handleLoadMore = async () => {
    if (!loading && hasMore) {
      setLoading(true);

      const {marketPosts, lastDoc: newLastDoc} = await fetchMarketPosts(
        'market_feeds',
        1,
        lastDocument,
      );

      if (marketPosts.length > 0) {
        setMarketPostsLoaded([...marketPostsLoaded, ...marketPosts]);
        setLastDocument(newLastDoc);
        console.log('loaded more');
      } else {
        setHasMore(false);
        console.log('reached the end');
      }

      setLoading(false);
    }
  };


<FlatList
                refreshControl={
                  <RefreshControl
                    refreshing={refreshing}
                    onRefresh={onRefresh}
                  />
                }
                onEndReached={handleLoadMore}
                onEndReachedThreshold={0}
                showsVerticalScrollIndicator={false}
                ListFooterComponent={
                  loading ? (
                    <View
                      style={{
                        height: 50,
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}>
                      <ActivityIndicator
                        size="small"
                        color={colors.primary_color}
                      />
                    </View>
                  ) : null
                }
                data={marketPostsLoaded}
                numColumns={2}
                renderItem={({item, index}) => (
                  <Pressable
                    onPress={() =>
                      navigation.navigate(Routes.POST_DETAIL, {
                        dataPassed: item,
                        selectedTabMenu: selectedTabMenu,
                      })
                    }
                    style={[
                      style.marketPostCardContainer,
                      {
                        marginRight: index % 2 === 0 ? 5 : 0,
                        marginLeft: index % 2 === 1 ? 5 : 0,
                      },
                    ]}
                    key={item.id}>
                    <View style={style.marketPostImageContainer}>
                      {item.images && item.images[0] ? (
                        <View>
                          <View style={style.badgeContainer}>
                            <Badge
                              title={item.postCategory}
                              paddingHorizontal={5}
                              fontSize={12}
                            />
                          </View>

                          <FastImage
                            source={{uri: item.images[0]}}
                            style={style.marketPostImage}
                          />
                        </View>
                      ) : (
                        <View
                          style={{
                            width: 170,
                            height: 170,
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}>
                          <ActivityIndicator />
                        </View>
                      )}
                    </View>
                    <View style={style.textContainer}>
                      <View style={style.titleContainer}>
                        <Text
                          style={[globalStyle.text, style.titleText]}
                          numberOfLines={1}>
                          {item.title}
                        </Text>
                      </View>
                      <View style={style.dateAuthorContainer}>
                        <Text
                          style={[globalStyle.text, style.dateText]}
                          numberOfLines={1}>
                          {formatFirestoreTimestampOnlyDate(item.createdAt)}
                        </Text>
                        <Text
                          style={[globalStyle.text, style.authorText]}
                          numberOfLines={1}>
                          {item.nickname}
                        </Text>
                      </View>
                      <View style={style.priceContainer}>
                        <Text
                          style={[globalStyle.text, style.prcieText]}
                          numberOfLines={1}>
                          \${item.price}
                        </Text>
                      </View>
                    </View>
                  </Pressable>
                )}
                ListHeaderComponent={() => (
                  <>
                    <View style={[style.headerTabsContainer]}>
                      <Pressable
                        style={style.tabMenuContainer}
                        onPress={() => navigation.replace(Routes.MARKET)}>
                        <Text
                          style={[globalStyle.text, style.tabMenuTextSelected]}>
                          중고마켓
                        </Text>
                      </Pressable>
                      <Pressable
                        style={style.tabMenuContainer}
                        onPress={() => navigation.replace(Routes.JOB)}>
                        <Text style={[globalStyle.text, style.tabMenuText]}>
                          구인구직
                        </Text>
                      </Pressable>
                      <Pressable
                        style={style.tabMenuContainer}
                        onPress={() => navigation.replace(Routes.PROPERTY)}>
                        <Text style={[globalStyle.text, style.tabMenuText]}>
                          부동산
                        </Text>
                      </Pressable>
                    </View>

                    <View style={[style.searchBarContainer]}>
                      <SearchBox disabled={true} />
                      <Pressable
                        style={style.bookmarkButtonContainer}
                        onPress={() => console.log('찜목록 버튼 눌림')}>
                        <Heart color={colors.primary_color} />
                        <Text
                          style={[globalStyle.text, style.bookmarkButtonText]}>
                          찜목록
                        </Text>
                      </Pressable>
                    </View>
                    <View style={style.marketCategoryTabsContainer}>
                      {marketCategories.map((item, index) => (
                        <Pressable
                          style={style.marketCategoryContainer}
                          onPress={() => setSelectedCategory(item)}
                          key={index}>
                          <Text
                            style={[
                              globalStyle.text,
                              selectedCategory === item
                                ? style.marketCategoryTextSelected
                                : style.marketCategoryText,
                            ]}>
                            {item}
                          </Text>
                        </Pressable>
                      ))}
                    </View>
                  </>
                )}
              />`,
      },
      {
        section_content:
          "The market posts will be stored in the ‘markets’ collection. The limit parameter decides how many new posts will be fetched every time user scrolls. The startAfter() method is used to continue fetching from the last document fetched. As user continue to scroll, the last document fetched will be continuously updated and returned. With this fetching flow, the function was attached to the FlatList handling function - handleLoadMore(). onEndReached prop will be triggered when user scrolls and reaches the onEndReachedThreshold value.  To render from recent post created, orderBy() method was used to sort the query. ",
      },
      {
        section_image: gogosingCompositeI,
        section_codes: `export const fetchReviews = async (restaurantId, callback) => {
  const query = firestore()
    .collection('reviews')
    .where('restaurant_id', '==', restaurantId)
    .orderBy('createdAt', 'desc');

  const unsubscribe = query.onSnapshot(async querySnapshot => {
    const reviews = [];

    for (const doc of querySnapshot.docs) {
      const data = doc.data();

      if (data.images) {
        const reviewImageUrls = await Promise.all(
          data.images.map(async image => {
            try {
              const imageRef = storage().ref(image);
              return imageRef.getDownloadURL();
            } catch (error) {
              const defaultLogoRef = storage().ref('/default_logo.png');
              return defaultLogoRef.getDownloadURL();
            }
          }),
        );

        data.images = reviewImageUrls;
      }
      reviews.push(data);
    }

    callback(reviews);
  });

  return unsubscribe;
};`,
      },
      {
        section_content:
          "For the review fetching, composite index had to be created in the Firebase Firestore console. This was because all the reviews are stored in one common collection ‘reviews’ and each restaurant reviews will be fetched by matching the restaurantId in the review created. Since it involved multiple fields, composite indexes were created for compound queries with multiple filters as seen in the code snippet above.",
      },
      {
        section_title: "Evaluation",
        section_content:
          "Started from May 2023, it is still ongoing project. Considering the scale of the project planned, it will probably take more time to be completed and released. One of the incomplete features is user comments feature. More knowledge and learning on data modelling are expected in my opinion. Also, other features such as wishlist, liked shops and products and OTP authentication without reCaptcha verification in iOS Xcode have to be implemented. Further update will be made on this post as the project progresses.",
      },
    ],
  },
  {
    id: 2,
    title: "Alomalo Humain Ent.",
    date: "30 May 2023",
    main_image: alomaloMainImage,
    subtitle:
      "Website for entertainment agency 'ALOMALO HUMAIN Ent.' in South Korea was designed and developed. Website previously built using WordPress was rebuilt using React.js",
    sections: [
      {
        section_title: "Ideation",
        section_subtitle: "Background",
        section_content:
          "This project was another opportunity to develop using React.js just before the final year in University of London. ‘Alomalo Humain Entertainment’ is an entertainment company in South Korea. The work was outsourced when two separate company, Alomalo Entertainment and Humain Entertainment, were merging. So, they were looking for a website developer who can migrate the two separate websites into one. The existing websites were built using WordExpress so the layouts were very simple and poorly developed.",
      },
      {
        section_subtitle: "Design References ",
        section_image: alomaloDesignRef1,
      },
      {
        section_image: alomaloDesignRef2,
        section_content:
          "After several Zoom meetings with the staff in charge of the project, I received the design references that can give better understanding of how they want their new website to look. One was the Just Entertainment and the other was BH Entertainment.",
      },
      {
        section_subtitle: "Project Requirements ",
        section_content:
          "Before I started the project, the requests received from Alomalo Humain Entertainment are as follow: ",
        section_bullets: [
          "For the navigation menu, there would be ‘Company’, ‘Artists’, ‘Multimedia’, ‘News’ and ‘Audition’. With ‘Company’ and ‘Artists’ menu and the pages, they would deliver the contents that could introduce the company profile and artists they have contracted. ",
          "They wanted pages where they could share and upload the news articles and YouTube videos of their artists. ",
          "Audition application form was not needed but there will be one page with audition details.",
        ],
      },
      {
        section_subtitle: "Challenges At The Early Phase of The Project ",
        section_content:
          "The time when I was embarking on the project was the period the two companies were merging and the size of two companies was relatively smaller than the two companies in the design references. So, resources to fill the website were very limited - artist profile images were mostly outdated and the qualities were also very poor to be used on the website. Other resources such as artist profile were passed in pdf format so it required extra time to clean and organise the data. ",
      },
      {
        section_content:
          "The main problem was that they had no experience outsourcing development work to third party and until this project, they utilised Social Networking Service such as Instagram and Facebook only for some marketing. Human resources assigned to this project from their end were only two people and they were also having zero experience in this work. They shared that the previous website was built using WordPress with some online basic tutorials.",
      },
      {
        section_title: "Design",
        section_subtitle: "Low-Mid Fidelity Design ",
        section_image: alomaloLFD,
        section_content:
          "Using the design tool Figma, the initial design of the website was developed. Unlike other projects where I developed design layouts first and modified based on the feedbacks received, in this project, the staffs in charge wanted to Zoom call and share ideas and develop the layouts together. I shared the minimum ideas because the design layout they expected was very clear. ",
      },
      {
        section_subtitle: "High-Fidelity Design ",
        section_image: alomaloHFD,
        section_content:
          "During the high-fidelity design development, it took very long to receive the resources. While waiting for the group photo taking schedule and other resources to be passed, I left the parts without resources using empty grey boxes and had to fill in one by one every time it was passed. It eventually delayed the entire project schedule but I could not just wait for them to prepare the necessary resources so I just started the development for the website layouts.",
      },
      {
        section_title: "Development",
        section_content:
          "The project requirements were pretty much simple so it did not demand advanced web development skills. ",
      },
      {
        section_subtitle: "Collapsed Section ",
        section_image: alomaloCollapse,
        section_content:
          "Instead of creating a detail page where each artist profile could be displayed, profile section was collapsed and would be expanded when specific artist was selected. ",
        section_codes: `import { Link } from "react-scroll";

import FooterActorPage from "../components/FooterActorPage";
import ImageActorGrid from "../components/ImageActorGrid";
import ArtistProfileGallery from "../components/ArtistProfileGallery";
import { useState, useEffect, useRef } from "react";

const ActorPage = () => {
  const [selectedArtist, setSelectedArtist] = useState("");
  const galleryRef = useRef(null);

  const handleSelectArtist = (artist) => {
    setSelectedArtist(artist);
  };

  useEffect(() => {
    if (selectedArtist !== "") {
      galleryRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [selectedArtist]);

  return (
    <>
      <div id="artist-page">
        <div className="artist-page container">
          <Link to="artist-profile-gallery" smooth={true}>
            <ImageActorGrid onSelectArtist={handleSelectArtist} />
          </Link>
          <div ref={galleryRef}>
            <ArtistProfileGallery selectedArtist={selectedArtist} />
          </div>
        </div>
      </div>
      <FooterActorPage/>
    </>
  );
};

export default ActorPage;`,
      },
      {
        section_content:
          "In the ActorPage and ArtistsPage, using the useState hook, selectedArtist state was created. With user selecting an artist from the grid, it will pass the selectedArtist state to the ArtistProfileGallery component.",
        section_codes: `import { galleryHandler } from "../utils/myFunction.js";
import artistData from "../data/artistData.js";

const ArtistProfileGallery = ({ selectedArtist }) => {
  const currentArtist = artistData.find(
    (artist) => artist.artist === selectedArtist
  );

  if (selectedArtist == "") {
    return <div></div>;
  } else {
    return (
      <div id="artist-profile-gallery">
        <div className="artist-profile-gallery container">
          <div className="artist flex-row">
            <div className="artist-profile-images flex-column">
              <div className="img-container">
                {<img src={currentArtist.images[0]} id="imageBox" alt="" />}
              </div>
            </div>

            <div className="artist-detail flex-column">
              <h1>{currentArtist.korName}</h1>
              <h2>{currentArtist.engName}</h2>
              <div className="artist-detail-row flex-row">
                <div className="artist-detail-col-1 flex-column">
                  {currentArtist.drama && currentArtist.drama.length > 0 && (
                    <>
                      <h3>드라마</h3>
                      {currentArtist.drama.map((drama, index) => (
                        <p key={index}>{drama}</p>
                      ))}
                    </>
                  )}

                  {currentArtist.profile && currentArtist.profile.length > 0 && (
                    <>
                      <h3>프로필</h3>
                      {currentArtist.profile.map((profile, index) => (
                        <p key={index}>{profile}</p>
                      ))}
                    </>
                  )}

                  {currentArtist.plays && currentArtist.plays.length > 0 && (
                    <>
                      <h3>연극</h3>
                      {currentArtist.plays.map((play, index) => (
                        <p key={index}>{play}</p>
                      ))}
                    </>
                  )}

                  {currentArtist.musics && currentArtist.musics.length > 0 && (
                    <>
                      <h3>음원</h3>
                      {currentArtist.musics.map((music, index) => (
                        <p key={index}>{music}</p>
                      ))}
                    </>
                  )}
                </div>

                <div className="artist-detail-col-2 flex-column">
                  {currentArtist.movies && currentArtist.movies.length > 0 && (
                    <>
                      <h3>영화</h3>
                      {currentArtist.movies.map((movie, index) => (
                        <p key={index}>{movie}</p>
                      ))}
                    </>
                  )}

                  {currentArtist.advs && currentArtist.advs.length > 0 && (
                    <>
                      <h3>광고</h3>
                      {currentArtist.advs.map((adv, index) => (
                        <p key={index}>{adv}</p>
                      ))}
                    </>
                  )}

                  {currentArtist.tvshows &&
                    currentArtist.tvshows.length > 0 && (
                      <>
                        <h3>TV 프로그램</h3>
                        {currentArtist.tvshows.map((tvshow, index) => (
                          <p key={index}>{tvshow}</p>
                        ))}
                      </>
                    )}

                  {currentArtist.musicals &&
                    currentArtist.musicals.length > 0 && (
                      <>
                        <h3>뮤지컬</h3>
                        {currentArtist.musicals.map((musical, index) => (
                          <p key={index}>{musical}</p>
                        ))}
                      </>
                    )}

                  {currentArtist.shorts && currentArtist.shorts.length > 0 && (
                    <>
                      <h3>단편</h3>
                      {currentArtist.shorts.map((short, index) => (
                        <p key={index}>{short}</p>
                      ))}
                    </>
                  )}

                  {currentArtist.careers &&
                    currentArtist.careers.length > 0 && (
                      <>
                        <h3>기타</h3>
                        {currentArtist.careers.map((career, index) => (
                          <p key={index}>{career}</p>
                        ))}
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default ArtistProfileGallery;`,
      },
      {
        section_content:
          "With the passed selectedArtist prop, in the ArtistProfileGallery component will match it against the data set and fetch the profile details data. The fetched data will render the profile detail component. For the error-handling, if statement was used to render empty <div> in the case of artist name does not exist matching the passed selectedArtist prop. ",
      },
      {
        section_content:
          "Also, for scrolling to the artist profile gallery section, useRef hook was used. scrollIntoView() method was used. When user selects an artist, it will automatically scroll to the top of the  ArtistProfileGallery component. ",
      },
      {
        section_subtitle: "Multimedia Page Embedding YouTube videos",
        section_codes: `import Footer from "../components/Footer";
import { useState, useEffect, useRef } from "react";

const MultimediaPage = () => {
  const [selectedVideo, setSelectedVideo] = useState("-FLH3QH5WQg");
  const videoMainRef = useRef(null);

  const handleVideoClick = (videoId) => {
    setSelectedVideo(videoId);
  };

  useEffect(() => {
    if (selectedVideo !== "") {
      videoMainRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [selectedVideo]);

  return (
    <>
      <div id="multimediapage">
        <div className="multimediapage container">
          <div className="news-card-title-outside" ref={videoMainRef}>
            <h1>MULTIMEDIA</h1>
          </div>
          <div className="multimedia-video-main">
            <iframe
              className="video-embed"
              src={\`https://www.youtube.com/embed/\${selectedVideo}\`}
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>

          <div className="multimedia-video-list flex-column">
            <div className="news-card-title-outside">
              <h1>LIST</h1>
            </div>
            <div className="multimedia-video-list-wrapper">
              <div
                className="multimedia-video-list-card"
                onClick={() => handleVideoClick("-FLH3QH5WQg")}
              >
                <img
                  src="https://img.youtube.com/vi/-FLH3QH5WQg/mqdefault.jpg"
                  alt=""
                />
                <p className="multimedia-title">
                  [#신랑수업] (울컥) ＂드디어 여기까지 왔다＂ 사야♥형탁 일본
                  결혼식! 꽃길만 걸으세요 #심형탁 #결혼 | 요즘남자라이프
                  신랑수업 76 회
                </p>
              </div>
              <div
                className="multimedia-video-list-card"
                onClick={() => handleVideoClick("Vz02z5sh0aw")}
              >
                <img
                  src="https://img.youtube.com/vi/Vz02z5sh0aw/mqdefault.jpg"
                  alt=""
                />
                <p className="multimedia-title">
                  [선공개] 달콤한 키스로 영원을 맹세하며 공식적으로 부부가 된
                  형탁♥사야 | 요즘남자라이프 신랑수업 76 회
                </p>
              </div>
              <div
                className="multimedia-video-list-card"
                onClick={() => handleVideoClick("_BhBxbYVQy4")}
              >
                <img
                  src="https://img.youtube.com/vi/_BhBxbYVQy4/mqdefault.jpg"
                  alt=""
                />
                <p className="multimedia-title">
                  [#신랑수업] 장인어른 만나 뚝딱거리는 심형탁! 사야 부모님이
                  말하는 심씨 첫인상은? #아저씨 #심형탁 | 요즘남자라이프
                  신랑수업 75 회
                </p>
              </div>
              <div
                className="multimedia-video-list-card"
                onClick={() => handleVideoClick("fBdNAvbCO5U")}
              >
                <img
                  src="https://img.youtube.com/vi/fBdNAvbCO5U/mqdefault.jpg"
                  alt=""
                />
                <p className="multimedia-title">
                  [선공개] 에몽이의 진심어린 응원에 폭풍 오열한 심형탁╥﹏╥ |
                  요즘남자라이프 신랑수업 74 회
                </p>
              </div>

              <div
                className="multimedia-video-list-card"
                onClick={() => handleVideoClick("7DHswDsTf98")}
              >
                <img
                  src="https://img.youtube.com/vi/7DHswDsTf98/mqdefault.jpg"
                  alt=""
                />
                <p className="multimedia-title">
                  프로 출신 파인비치 대표님을 이겨라! 골프 좀 친다는 배우 인맥
                  총동원! 이 섭외가 가능하다고?ㅣ1화
                </p>
              </div>

              <div
                className="multimedia-video-list-card"
                onClick={() => handleVideoClick("5P7rKxNSpxk")}
              >
                <img
                  src="https://img.youtube.com/vi/5P7rKxNSpxk/mqdefault.jpg"
                  alt=""
                />
                <p className="multimedia-title">
                  심형탁, 아내와 결혼을 결심하게 된 계기♥
                </p>
              </div>

              <div
                className="multimedia-video-list-card"
                onClick={() => handleVideoClick("a9YNYq8chXc")}
              >
                <img
                  src="https://img.youtube.com/vi/a9YNYq8chXc/mqdefault.jpg"
                  alt=""
                />
                <p className="multimedia-title">
                  우린 그걸 4차원이라 하기로 했어요 모두를 웃겨 놓고 정작 본인만
                  무표정인 게 ㄹㅇ킬포
                </p>
              </div>

              <div
                className="multimedia-video-list-card"
                onClick={() => handleVideoClick("Mc5g4k_AX8w")}
              >
                <img
                  src="https://img.youtube.com/vi/Mc5g4k_AX8w/mqdefault.jpg"
                  alt=""
                />
                <p className="multimedia-title">
                  신지민(SHIN JIMIN) 'Sympathy' Official MV
                </p>
              </div>

              <div
                className="multimedia-video-list-card"
                onClick={() => handleVideoClick("n3iOJeeZLcQ")}
              >
                <img
                  src="https://img.youtube.com/vi/n3iOJeeZLcQ/mqdefault.jpg"
                  alt=""
                />
                <p className="multimedia-title">
                  [#군조율동조합] 월드스타가 되기 위해 회장님에게 구걸한 ssul.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MultimediaPage;`,
      },
      {
        section_content:
          "In the multimedia page, there will be top section where user can play the embedded YouTube video and grid section with YouTube thumbnails they can choose to play. It works similar to the original YouTube web application where users can play video while they can select from the video recommendation area to play. ",
      },
      {
        section_content:
          "It was the first time to embed video resources on the website so I had to research how it could be done. <iframe> element was used. At first, I thought the url that can be copied from the browser could be used for the src attribute of the iframe tag. It did not work as I expected and found out that I had to use the embed link from the share menu in the YouTube. ",
      },
      {
        section_content:
          "Also, for the thumbnail images of each video, there were not answers I could find from Google search results and ChatGPT suggested the solution that ‘https://img.youtube.com/vi/[video-9d]/mqdefault.jpg’ could be used. With the repetitive format of video embedding and thumbnail link, I only had to switch the video-id from YouTube. As seen in the code snippets above, useState hook was also used to manage the state at the component-level. When user selects a video from the thumbnail grid, it will switch the selected video state and it will be passed to the <iframe> tag for video to be played. ",
      },
      {
        section_subtitle: "News Article in A New Browser Tab",
        section_codes: `<a href={data.url} target="_blank">
        <div className="news-cards-item flex-column">
          <div className="news-cards-item-img">
            <img src={data.img} alt="" />
          </div>
          <div className="news-cards-item-title">
            <p>{data.title}</p>
          </div>
        </div>
      </a>`,
      },
      {
        section_content:
          "Simple work but revised during the project, to open the new article link in a new browser tab, ‘target’ attribute was added to the <a> element. With the value ‘_blank’, it will redirect to the attached url in a new tab. ",
      },
      {
        section_title: "Evaluation",
        section_content:
          "It was the second project that I developed website with React.js. The difficulty, time spent and structure of the entire website were not demanding high skill set but I believe the learning from the previous React.js project was reflected - utilisation of React state and prop in between components. Apart from the development, it was challenging project because there were lots of miscommunication and last minute modifications nearing the completion of the project. However, there were still many parts I could develop both hard and soft skills as a software engineer.",
      },
    ],
  },
  {
    id: 3,
    title: "ONSTAMP",
    date: "28 December 2022",
    main_image: onstampMainImage,
    subtitle:
      "Mobile application for iOS and Android designed and created to digitalise traditional paper stamps issued from various restaurants in Singapore. Customers can collect digital stamps while dining and get rewards.",
    sections: [
      {
        section_title: "Ideation",
        section_subtitle: "Background",
        section_content:
          "The project ideation started as I lived here in Singapore and visited several restaurants in Singapore. I have seen many small business owners in various sectors handing out paper coupons to customers. This includes F&B and beauty care businesses. ",
      },
      {
        section_image: onstampEx1,
      },
      {
        section_image: onstampEx2,
        section_content:
          "The stamp coupons typically serve different purposes in business :",
        section_bullets: [
          "Promotional Tool - business offers discounts, special deals or other incentives to encourage customers to make a purchase or try a new product or service",
          "Customer Loyalty - stamps are often used as part of loyalty programs where customers earn a stamp for each purchase. Collected stamps can be redeemed for discounts, free products, or other rewards",
          "Incentives for Return Visits - It encourages repeat business. Customers may be more likely to return to a business if they know they are working toward a reward through stamps being collected.",
        ],
      },
      {
        section_content:
          "In the case of businesses in a relatively large size - having multiple branches in Singapore - they invested in mobile application development and digitalised existing traditional paper coupons or stamp coupons to provide customers with membership programs. However, small business owners who only run one store were still using paper coupons because the application development cost is quite high, considering the limited size of consumers.",
      },
      {
        section_content:
          "In fact, when I talked to some business owners, some of them also thought this, but considering the cost of developing and maintaining the application, printing and distributing paper coupons would be much better for saving money. ",
      },
      {
        section_content:
          "Considering the usage of paper stamp coupons from the user-end, these days it is difficult to see people carrying wallets. The main reason can be the increased volume of digital wallets users. Various digital wallet platforms such as Apple Pay, GrabPay, and Samsung Pay have appeared, and there are no problems in life even if you do not carry your wallet with credit cards or cash. With this phenomenon, it has been found that many customers lose or throw away most of the paper coupons after their first visit - difficult to keep them for the next visit and stamps. ",
      },
      {
        section_content:
          "With such idea and consideration, I thought centralised digital platform where different small businesses owners can register their stores, and customers can download coupons and collect digital stamps, are needed.",
      },
      {
        section_subtitle: "Initial Consideration for The Project",
        section_image: onstampAndroidIos,
        section_content:
          "Before this project, I had opportunities to learn Kotlin and Android Development through online courses. There were not much project experience for mobile application and I thought it was possible to develop both native mobile application - iOS and Android. However, the project plan and idea required higher skills than I had expected and I realised how time-consuming and challenging it would be to develop both native mobile applications alone. If I could carry out the project with other team members with different skill stack, the project would have been feasible. However, it was hard to find people who can see the problem and share the common thoughts for this project in my school. ",
      },
      {
        section_image: rnThumb,
        section_content:
          "So, as a solution to the challenge I faced at this point of time, ‘React Native’ was considered. React Native is JavaScript cross-platform mobile application development framework and there are key benefits as follow : ",
        section_bullets: [
          "Code-Reusability: A significant portion of the codebase can be reused for both iOS and Android platforms. ",
          "Cost-Effectiveness: Only single codebase can be written for both platforms and this reduces cost for development and maintenance. ",
          "Time Efficiency: It can accelerate development since changes made in the single codebase can be applied to both platforms simultaneously.",
          "Hot Reloading: Unlike the development in Kotlin or Swift, React Native provides hot reloading feature which allows developers to see the result of the latest change immediately without building and running the application. ",
        ],
      },
      {
        section_content:
          "With these advantages of React Native, I concluded that it meets the requirements of the project - solo project and lacking experience of native app development.",
      },
      {
        section_subtitle: "Key Features of The Application ",
        section_content: "The main objective of the project were:",
        section_bullets: [
          "To provide both business owners and customers a digital platform where business marketing can be done",
          "To allow customers collect membership stamp coupons",
          "To enable customers easily access to store information and promotional contents.",
        ],
      },
      {
        section_title: "Design",
        section_subtitle: "Design Sketch",
        section_image: onstampLFD,
      },
      {
        section_image: onstampLFD2,
      },
      {
        section_content:
          "4 main screens were planned and designed by hand-sketch - Home, Explore, Stamps, Account",
      },
      {
        section_content:
          "In the home screen, promotional image carousel would be positioned at the top. The rest of the screen space would be filled with registered store image card from where user could select and navigate to the store detail information screen.",
      },
      {
        section_content:
          "Explore screen would wrap all the events and promotions from different stores. Users would be able to explore various event and promotion, and collect coupons and discount codes here.",
      },
      {
        section_content:
          "In every store detail screen, it would contain stamp download button. When user downloads one, it would be stored in their stamps menu. In the stamps screen, it would render user membership card with QR code for scan. The QR code would contain the user account uid value. Retails would scan each user’s QR code to access and modify the stamp details.",
      },
      {
        section_content:
          "Users could edit their user profile and other related data in the Account screen. They would sign out and delete account in this screen.",
      },
      {
        section_subtitle: "Finalised Design",
        section_image: onstampDesign,
        section_content:
          "From the initial design sketch, user interface design was finalised.",
      },
      {
        section_content:
          "The screen stack was separated for unauthorised user and authorised user. For new user, they would be navigated to the onboarding screen. In the onboarding screen, three different screens would give introduction to the application. The user authentication would be done via phone authentication so in the sign up screen, user would enter their mobile number and fill out the user detail. ",
      },
      {
        section_content:
          "The four menu planned were maintained and implemented as bottom navigation menu. In the finalised design, stamp coupon design, store detail screen and promotion detail screen were newly added.",
      },
      {
        section_title: "Development",
        section_content:
          "The challenge encountered as the project moving on to the development phase was the backend handling. For the frontend of the mobile application, React Native was more than enough and this was the part I could manage. Creating the entire server structure and database required at the level for this project demanded extra time to learn the required skills. So, the alternative for the backend part was serverless architecture. ",
      },
      {
        section_image: firebaseThumb,
        section_content:
          "One option was Firebase from Google. From the perspective of backend development, it was very useful approach as it provides features such as serverless architecture, real-time database, user authentication, cloud storage and etc. This allowed the project to be built more focused on frontend and business logic without managing server infrastructure. ",
      },
      {
        section_content:
          "So the skill stack to be used for the project could be summarised as React Native, Firebase, and Redux-toolkit for state management. ",
      },
      {
        section_content:
          "In this section, key features of the project and how they were implemented will be described and explained with images and code snippets.",
      },
      {
        section_subtitle: "File Structure of The Project",
        section_mobile: onstampFS,
        section_content:
          "All the codes were managed in the ‘src’ directory which contains separate directories as seen above.",
      },
      {
        section_content:
          "‘api’ directory was created for codes related to handling data from Firebase and ‘redux’ directory was containing codes for the app-level data storage and state management. Also, for screen navigation and related codes were managed in the navigation directory. Similar to React.js project, screen component and re-usable component codes were managed separately. In the ‘hooks’ and ‘utils’ directories, custom hooks in React.js and other utility functions were created and managed.",
      },
      {
        section_subtitle: "Screen Navigation",
        section_content:
          "For the screen navigation, ‘@react-navigation/native’ package was installed and used. For the screen navigation stack structure, ‘MainNavigation.js’ and ‘index.js’, two separate files were created in the navigation directory. In the ‘MainNavigation.js’, depending on the user authentication status, different stack of screens will be loaded as seen below. ",
        section_codes: `import React, {useState, useEffect} from 'react';
import {NavigationContainer} from '@react-navigation/native';
// Different Stacks
import HomeStack from './HomeStack';
import AuthStack from './AuthStack';
import AdminStack from './AdminStack';
import auth from '@react-native-firebase/auth';
import {useSelector} from 'react-redux';

const MainNavigation = () => {
  const [initializing, setInitializing] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const isSignupDone = useSelector(state => state.users.isSignupDone);
  const isSignedIn = useSelector(state => state.users.isSignedIn);
  const {userData} = useSelector(state => state.users);

  useEffect(() => {
    // Set up an observer on Firebase Authentication to check the user's authentication state
    const unsubscribe = auth().onAuthStateChanged(authenticatedUser => {
      setCurrentUser(authenticatedUser);
      if (initializing) {
        setInitializing(false);
      }
    });

    // Clean up the observer when the component unmounts
    return unsubscribe;
  }, []);

  if (initializing) {
    return null;
  }

  return (
    <NavigationContainer>
      {currentUser && userData.isAdmin ? (
        <AdminStack />
      ) : currentUser && (isSignupDone || isSignedIn) ? (
        <HomeStack />
      ) : (
        <AuthStack />
      )}
    </NavigationContainer>
  );
};

export default MainNavigation;`,
      },
      {
        section_mobile: onstampFS2,
        section_content:
          "There were 3 different screen stacks - ‘AdminStack’, ‘AuthStack’, and ‘HomeStack’. ‘AdminStack’ was created for admin accounts which are given to business owners and stamp management for their retail could be done within the ‘AdminStack’. The ‘AuthStack’ consisted of all the screens required for unauthenticated user to sign-in, verify phone number, receive OTP, and sign-up. Lastly, ‘HomeStack’ contains screens for the authenticated user as seen in the design plan - Home, Explore, Stamps, and Account.",
        section_codes: `import {Provider} from 'react-redux';
import store, {persistor} from '../redux/store';
import {PersistGate} from 'redux-persist/integration/react';
import MainNavigation from './MainNavigation';

/**
 * Wrap all providers here
 */

export default function Routes() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={null}>
        <MainNavigation />
      </PersistGate>
    </Provider>
  );
}`,
      },
      {
        section_content:
          "In the ‘index.js’ file in ‘navigation’ directory, the MainNavigation component created was imported and together with the navigation setting, it sets up the Redux store and integrates Redux persist for state persistence. By wrapping with <Provider>, the entire application can access the Redux store.",
      },
      {
        section_subtitle: "Redux-Toolkit",
        section_content:
          "For efficient state management throughout the application, Redux-Toolkit was used. The initial configuration was done in the ‘store.js’ in ‘redux’ directory.",
      },
      {
        section_mobile: onstampFS3,
        section_content:
          "There were 4 slices created for this project as seen above. ‘UserSlice’ handles user authentication and stores states related to user information. ‘RestaurantSlice’ and ‘PromotionSlice’ stores the data fetched from the Firebase Firestore. By storing fetched data in app-level state, I could minimise the unnecessary requests to the server for the same data again and again when user runs the application. Lastly ‘StampSlice’ stores the downloaded stamp vouchers. This handles both logic for user stamp storage and admin updating users’ stamp status.",
        section_codes: `import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from '@reduxjs/toolkit';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {persistReducer, persistStore} from 'redux-persist';
import {logger} from 'redux-logger';

import UserSlice from './reducers/UserSlice';
import PromotionSlice from './reducers/PromotionSlice';
import RestaurantSlice from './reducers/RestaurantSlice';
import StampSlice from './reducers/StampSlice';

const rootReducer = combineReducers({
  users: UserSlice,
  promotions: PromotionSlice,
  restaurants: RestaurantSlice,
  stamp: StampSlice,
});

const configuration = {
  key: 'root',
  storage: AsyncStorage,
  version: 1,
};
const persistedReducer = persistReducer(configuration, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware => {
    return getDefaultMiddleware({
      serializableCheck: false,
    });
    // .concat(logger);
  },
});

export default store;
export const persistor = persistStore(store);`,
      },
      {
        section_content:
          "Together with the ‘async-storage’, persistReducer and persistStore from redux-persist maintained the redux states in the local memory. This enabled once-authenticated user to be directly navigated to the HomeStack when they re-runs the application after the initial authentication. This saved the cost for OTP verification.",
      },
      {
        section_image: otp1,
      },
      {
        section_image: otp2,
      },
      {
        section_image: otp3,
        section_content:
          "It has already been discussed in the blog post in this portfolio website but to briefly summarise how it was implemented, Firebase Phone Authentication feature was used and it had to be done with a little trick due to the limited access to user data. ",
      },
      {
        section_content:
          "For user authentication in Firebase console, there were two options that could fit into my project - Email & Password verification and Phone Authentication. The reason why I wanted phone authentication was because of better user experience in the application. Based on the personal experience and feedbacks from people around, many did not prefer email authentication because  including myself, many have different email accounts. So, I thought if time spent for an application is not very high, the email address used for verification could be easily forgotten. However, phone number is hardly forgotten and it does not require individual to remember the password. ",
      },
      {
        section_content:
          "The phone authentication feature provided by Firebase SDK, however, was very limited in its features. What I planned and expected from it was that user could enter their mobile number and got the number verified, to prevent misuse of random number. The Firebase mobile authentication would automatically send OTP code to the entered mobile number, and once it was verified, it would create a new user account with the mobile number. This immediately navigated user to the HomeStack as the logic I set in the main navigation, listening to the user auth status change with onAuthStateChanged method, would detect that the new user was already signed in. I just wanted to make sure the mobile number entered from new user is valid and not used by others already. ",
        section_codes: `const handleVerifyOTP = async () => {
    try {
      const data = await verifyOTP(confirmResult, codeEntered);
      if (data) {
        navigation.navigate('signup');
        console.log('Registered and signed in with phone number');
        const unsubscribe = auth().onAuthStateChanged(async user => {
          if (user) {
            // Delete the user from Firebase Authentication
            await user.delete();
            console.log('User deleted successfully.');
            // Clear confirmResult from otp verification
            dispatch(updateConfirmResult(null));

            // Unsubscribe the listener to avoid memory leaks
            unsubscribe();
          }
        });
      } else {
        console.log('Failed to verify OTP');
      }
    } catch (error) {
      console.log('Error verifying OTP:', error);
    }
  }; `,
      },
      {
        section_content:
          "One solution found, not the best, was using ‘verification function’ of the Firebase Phone Authentication partly. As seen in the code above, when user successfully verified the entered phone number, it would update the auth status and also create new account with the phone number they verified. However, I deleted the newly created user immediately. When the verification was done, it would trigger that valid mobile was used but the account created was immediately deleted. So, the signing up user would remain in the state ‘unauthenticated’. This would allow the application to proceed to the sign up screen for user profile data to be filled in.",
      },
      {
        section_subtitle: "Digital Stamp Management for Individual User",
        section_mobile: stampScreen,
        section_content:
          "Each signed up user would have an unique id generated by Firebase. I made use of this uid for verification and data storage for individual user in the database. In the Stamp screen, each user account would have digital membership card with QR code containing their uid. This QR code is scanned by each business owner and stamp will be given to a specific stamp downloaded.",
      },
      {
        section_image: stamp1,
        section_codes: `// Download a stamp voucher and store it in user's downloadedVouchers
export const downloadStampVoucher = (userUid, voucherId) => {
  return async dispatch => {
    try {
      const voucherDocRef = firestore().collection('vouchers').doc(voucherId);
      const voucherDoc = await voucherDocRef.get();
      if (voucherDoc.exists) {
        const voucherData = voucherDoc.data();

        // Get the current date
        const currentDate = new Date();

        const downloadedVoucher = {
          voucherId: voucherId,
          stampsCollected: 0, // Initialize collected stamps
          downloadedDate: currentDate, // Store the current date
          ...voucherData,
        };

        await firestore()
          .collection('users')
          .doc(userUid)
          .collection('downloadedVouchers')
          .doc(voucherId)
          .set(downloadedVoucher);
      }
    } catch (error) {
      console.error('Error downloading stamp voucher:', error);
      return null;
    }
  };
};`,
      },
      {
        section_content:
          "In the store detail screen, user could choose to download and store it in the stamp menu. The downloaded stamp coupon will be stored in the Firestore user document sub-collection ‘downloadedVouchers’. ",
      },
      {
        section_image: onstampDb,
        section_content:
          "When admin scans the user QR code, the scanned QR code and uid contained inside will give admin the location of the user’s downloaded voucher. When number of stamps is updated from the admin-end, it will be reflected on user’s stamp.",
      },
      {
        section_image: stamp2,
        section_content:
          "When user wants to delete the downloaded stamp coupon, it will remove the selected coupon from the user’s sub-collection and be reflected on user’s end.",
        section_codes: `export const deleteStampVouchers = (userUid, voucherId) => {
  return async dispatch => {
    try {
      await firestore()
        .collection('users')
        .doc(userUid)
        .collection('downloadedVouchers')
        .doc(voucherId)
        .delete();
    } catch (error) {}
  };
};`,
      },
      {
        section_subtitle: "Maintaining User Stamp Data ",
        section_codes: `export const fetchDownloadedVouchersFromFirestore = userUid => {
  return async dispatch => {
    try {
      // Set up a real-time listener for the downloaded vouchers collection
      const unsubscribe = firestore()
        .collection('users')
        .doc(userUid)
        .collection('downloadedVouchers')
        .onSnapshot(async snapshot => {
          const downloadedVouchers = await Promise.all(
            snapshot.docs.map(async doc => {
              const data = doc.data();

              // Get download URLs for background image and voucher logo
              const filledStampImageUrl = await storage()
                .ref(data.filledStamp) // Replace with your field name
                .getDownloadURL();
              const emptyStampImageUrl = await storage()
                .ref(data.emptyStamp)
                .getDownloadURL();
              const logoImageUrl = await storage()
                .ref(data.logoImage)
                .getDownloadURL();
              const voucherBgUrl = await storage()
                .ref(data.voucherBg)
                .getDownloadURL();

              return {
                ...data,
                filledStamp: filledStampImageUrl,
                emptyStamp: emptyStampImageUrl,
                logoImage: logoImageUrl,
                voucherBg: voucherBgUrl,
              };
            }),
          );
          console.log(
            'downloadedVoucher data after download is detected by realtime listener',
            downloadedVouchers,
          );
          dispatch(fetchDownloadedVouchersSuccess(downloadedVouchers)); // Update store with new data
        });

      // Unsubscribe the real-time listener when the component unmounts
      return () => {
        if (unsubscribe) {
          unsubscribe();
        }
      };
    } catch (error) {
      console.error('Error fetching downloaded vouchers:', error);
      dispatch(fetchDownloadedVouchersFailure(error));
    }
  };
};`,
      },
      {
        section_codes: `import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  downloadedVouchers: [], // User's downloaded vouchers
  loading: fal
};

const stampSlice = createSlice({
  name: 'stamp',
  initialState,
  reducers: {
    // addDownloadedVoucher: (state, action) => {
    //   state.downloadedVouchers = action.payload;
    // },
    updateStampsCollected: (state, action) => {
      const {voucherId, stampsCollected} = action.payload;
      const voucher = state.downloadedVouchers.find(
        voucher => voucher.voucherId === voucherId,
      );
      if (voucher) {
        voucher.stampsCollected = stampsCollected;
      }
    },
    fetchDownloadedVouchersStart: state => {
      state.loading = true;
      state.error = null;
    },
    fetchDownloadedVouchersSuccess: (state, action) => {
      state.downloadedVouchers = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchDownloadedVouchersFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetToInitialStamp: () => {
      return initialState;
    },
  },
});

export const {
  // addDownloadedVoucher,
  updateStampsCollected,
  fetchDownloadedVouchersStart,
  fetchDownloadedVouchersSuccess,
  fetchDownloadedVouchersFailure,
  resetToInitialStamp,
} = stampSlice.actions;

export default stampSlice.reducer;`,
      },
      {
        section_content:
          "When user closes the application and re-runs it in the future, the downloaded stamp data should remain. To implement this, the function ‘fetchDownloadedVouchersFromFirestore’ was created and in the useEffect hook in the Stamp screen, it was called. The fetched stamp data is stored in the redux state as downloadedVouchers.",
      },
      {
        section_subtitle: "Custom Modal for QR Code ",
        section_image: stamp3,
        section_content:
          "Considering the different screen size of various mobile devices, the QR code of the digital membership card in the stamp screen could possibly not be scanned successfully. So I created a custom modal to display the user’s QR code in larger size.",
        section_codes: `import {Text, View, Modal, TouchableOpacity, Image} from 'react-native';
import React from 'react';
import style from './style';
import QRcode from '../QRcode/QRcode';
import LinearGradient from 'react-native-linear-gradient';
import {horizontalScale} from '../../../assets/styles/scaling';
import globalStyle from '../../../assets/styles/globalStyle';
import {FontAwesomeIcon} from '@fortawesome/react-native-fontawesome';
import {faArrowLeft, faX} from '@fortawesome/free-solid-svg-icons';

const QRCodeModal = ({visible, onClose}) => {
  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={visible}
      onRequestClose={onClose}>
      <View style={style.modalContainer}>
        <LinearGradient
          colors={['#00155A', '#03009D']}
          start={{x: 0, y: 0.5}}
          end={{x: 1, y: 0.5}}
          style={style.modalContent}>
          <View style={style.qrCodeContainer}>
            <Image
              style={style.logo}
              source={require('../../../assets/images/onstamp-logo-logotext.png')}
            />
            <QRcode size={horizontalScale(180)} style={style.qrCode} />
          </View>
          <TouchableOpacity onPress={onClose} style={style.closeButton}>
            <FontAwesomeIcon icon={faX} size={30} color={'#fff'} />
          </TouchableOpacity>
        </LinearGradient>
      </View>
    </Modal>
  );
};

export default QRCodeModal;`,
      },
      {
        section_codes: `const [qrCodemodalVisible, setQrCodemodalVisible] = useState(false);

<QRCodeModal
          visible={qrCodemodalVisible}
          onClose={() => setQrCodemodalVisible(false)}
        />

<View style={style.iconsContainer}>
            <Pressable
              onPress={() => setQrCodemodalVisible(true)}
              style={style.iconImageContainer}>
              <Image
                style={style.iconImage}
                source={require('../../../../assets/images/qrcodeicon.png')}
              />
            </Pressable>
            {/* <FontAwesomeIcon icon={faBell} size={24} style={style.icon} /> */}
          </View>`,
      },
      {
        section_title: "Evaluation",
        section_content:
          "Apart from the toy projects that were done using React Native, it was my first React Native project that I carried out from the initial design to development. It was great learning period that I could improve understandings on skills such as React hooks, project structure management, and how native codes work from the codebase written in React Native. Also, I did not have much experience with Redux but throughout the project, I could learn how useful and important the centralised store is and how it allows different components in the application to have access to different states. ",
      },
      {
        section_content:
          "However, there were many challenges from the beginning to the end of the project. Not mentioned in this post but initially development in React Native was started with RN Expo. For simple features, Expo was indeed a great approach but it had lots of compatibility issues with the latest Firebase version - especially for phone authentication. I tried to figure out the reasons for several bugs and errors thrown but eventually it turned out to be the internal version compatibility issue between RN Expo and Firebase. So, after 2 months of development in React Native Expo, I had no option but to migrate the project into RN Cli. ",
      },
      {
        section_content:
          "if I take this project into the actual business as a digital wallet platform market, there are a lot to improve. Firebase was a good option but considering the size of the user base increasing and scalability of the application, it could end up being so costly to maintain the server.",
      },
      {
        section_content:
          "Overall, the project was successful since key features of user authentication and digital stamp features were all implemented. ",
      },
    ],
  },
  {
    id: 4,
    title: "O.BBa Singapore",
    date: "19 December 2021",
    main_image: obbaMainImage,
    subtitle:
      "Website for Korean restaurant brand O.BBa Singapore was designed and developed. Brand contents, which were previously uploaded and managed on Facebook pages, were gathered in one place to make it easier for customers to access information such as restaurant menu and locations.",
    sections: [
      {
        section_title: "Ideation",
        section_subtitle: "Background",
        section_content:
          "O.BBa is one of the most famous Korean restaurants in Singapore, and when I first met with the founder, Mr Han, they had already opened up the 4th branch at Tanjong Pagar Road. ",
      },
      {
        section_content:
          "It was during the period right after my first year in University of London. I was looking for opportunities to participate in real projects, and for that, internship during the school break was the best option. However, as a foreign student residing in Singapore with Student Pass, I was not allowed to do internship or work. I could not wait until the graduation so I started thinking about other options. One day one video on YouTube came across and it was about non-paid projects. The software engineer in the video was sharing his experience during his university years how he had no opportunities for internship but turned the situations around by approaching people in business to offer them free projects for his development experience. This was exactly the best option I could have at that time. So I contacted people I know in Singapore and offered free website building service.",
      },
      {
        section_content:
          "When I first spoke with Mr Han, his brand was running the Facebook pages for each branch separately. At that time, the number of Facebook users leaving was significantly increasing and he was having difficulties to create and manage the pages as his business grows. He wanted to merge all the contents into one common website. ",
      },
      {
        section_content:
          "It was my first project apart from the school works. Also, I honestly had not sufficient skills in programming - only HTML, CSS and some basic JavaScript. Since I had to do the entire project from initial design to development alone, I needed lots of references and research.",
      },
      {
        section_title: "Design",
        section_content:
          "I started the project design from looking through the existing Facebook pages to get more ideas how I should merge the existing digital contents for the brand. Their main usage of the Facebook page was to display the restaurant menu and to upload promotional contents. The main problems I found and also the ones Mr Han mentioned were:",
        section_bullets: [
          "Same content has to be uploaded for each page - requires Mr Han to sign in and sign out for 4 different accounts.",
          "Facebook page renders contents in the chronological stream - page feed. Old feeds will be only seen when users scrolls the feed to fetch more data.",
          "Menu can be uploaded as images but user had to search for them by navigating to gallery menu - Mr Han thought it is not so visible to users.",
          "Customer-Restaurant interaction was being done through Facebook Messenger but he wanted it to be done via company email. ",
        ],
      },
      {
        section_content:
          "In addition, the main features he requested were location page that provides each branch information, forms users can submit for franchise and other general enquiries, and shop page which can redirect to a link to e-commerce website.",
      },
      {
        section_subtitle: "Low-Fidelity Design",
        section_image: obbaLFD,
        section_content:
          "Considering the project requirements based on the requests from Mr Han, 6 main menu were planned - Home, Menu, Location, Franchise, Customer and Shop. The initial low-fidelity design was done by hand sketching. ",
      },
      {
        section_subtitle: "Mid-Fidelity Design",
        section_image: obbaMFD,
        section_content:
          "From the earlier low-fidelity design, more details were added and planned in grid form. Based on this, each section was further developed at the high-fidelity design phase with actual images, text content, buttons and etc that would be used for website user interface.",
      },
      {
        section_subtitle: "High-Fidelity Design ",
        section_image: obbaHFD,
        section_content:
          "The final user interface was iteratively developed through the 3 of reviews from Mr Han. Design tool Figma was used to create each detail but it was the first time using Figma, so it took extra time for me to pick up the tool features and designing skills. The images were collected from the existing Facebook pages and directly from Mr Han and store managers.",
      },
      {
        section_title: "Development",
        section_content:
          "With the finalised website design plan, each page was coded using HTML and CSS. In this section, key features of the website, barriers encountered during the development and how they were overcome are described and elaborated. ",
      },
      {
        section_subtitle: "Image Carousel",
        section_image: obbaSwiperJs,
        section_content:
          "At the initial development phase, the Home page required image carousel which can show the main events and promotions for the brand. At the time, I lacked the concept and understanding of the JavaScript library and did not have much experience of using them, I made references to YouTube tutorials and tried to implement it in vanilla JavaScript for the first few weeks. ",
      },
      {
        section_content:
          "Implementation was possible and it was okay but was not fully satisfactory - animation was not smooth enough and it was very time consuming to make it responsive to different screen size. Some blog posts and YouTube tutorial videos on Swiper.js were found and I decided to use it for sliders for different sections of the website.",
      },
      {
        section_codes: `const swiper = new Swiper('.swiper-hero', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  autoplay: {
      delay: 3000,
  }
});


<!-- Slider main container -->
<div class="swiper swiper-hero">
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper">
        
        <!--<div class="swiper-slide">-->
        <!--    <img class="hero-img" src="../../img/main-banner-tsy.jpg" alt="main-banner-2">-->
        <!--</div>-->
        <!-- Slide 3 -->
        <div class="swiper-slide">
            <img class="hero-img" src="../../img/test-banner7.png" alt="main-banner-2">
        </div>

        <!-- Slide 4 -->
        <div class="swiper-slide">
            <img class="hero-img" src="../../img/test-banner6.png" alt="main-banner-2">
        </div>

        <div class="swiper-slide">
            <img class="hero-img" src="../../img/test-banner8.png" alt="main-banner-2">
        </div>
        <div class="swiper-slide">
            <img class="hero-img" src="../../img/mobilebanner-19.jpeg" alt="main-banner-2">
        </div>
    </div>

    <!-- If we need pagination -->
    <div class="swiper-pagination"></div>
</div>`,
      },
      {
        section_content:
          "The configuration was done in a separate file as above. The official documentation was referred from the Swiper.js website. The key benefits of Swiper.js were that features commonly used in image carousel were already provided - loop, autoplay, delay setting and pagination. Since it was the first time using it, it took extra time to implement it but the rest of the usage in this project was quick and time-saving. ",
      },
      {
        section_subtitle: "Navigation Menu",
        section_image: obbaNavMenu,
        section_codes: `#navbar.scrolled {
    position: fixed;
    height: 55px;
    background: #fff;
    box-shadow: 1px 1px 5px rgb(182, 182, 182);
    z-index: 2222;
    border-bottom: none;
    -webkit-transform: translateZ(0);
}

#navbar.scrolled ul li a {
    padding: 5px 15px;
}


window.addEventListener("scroll", () => {
    let navbar = document.querySelector('nav');
    navbar.classList.toggle("scrolled", window.scrollY > 10);
})`,
      },
      {
        section_content:
          "When user scrolls the screen, I wanted the navigation bar to get smaller in height with animation. Also, the navigation menu was positioned at the top - fixed. DOM manipulation using vanilla JavaScript was done as seen in the code above. When the scrollY value is greater than 10 pixels, class ‘scrolled’ will be added to the navbar class. Initially add() and remove() methods were used to add and remove the ‘scrolled’ class but toggle method was found and the code got much simpler. ",
      },
      {
        section_subtitle: "Form Submission to Company Email",
        section_image: obbaFormSubmit,
        section_content:
          "Since this project was just static website with no interaction between client and server and the skill I had to complete the project was quite limited, form submission to target email address was another barrier. However, I tried to search up on google with keyword ‘form submission without backend’ and ‘formsubmit.co’ was found. With the codes provided, when user submit a form, it will be sent to the Formsubmit.co server and it will redirect it to the email address I set. Not the best option, but the problem Mr Han mentioned was, to a certain extent, resolved with it. ",
      },
      {
        section_title: "Deployment",
        section_image: obbaHostinger,
        section_content:
          "Web hosting provider ‘Hostinger’ was selected to deploy the project. The website domain was purchased through Google Domains. For the testing of the entire project, project files were uploaded first without pointing the Hostinger nameservers to Google Domain purchased.",
      },
      {
        section_title: "Testing & Review",
        section_content:
          "When website was loaded, it was spotted that the image loading was taking so long and also, the analysis tool provided by Hostinger indicated that the performance score was 26. This was mainly because images used in the website were very large in size. So images were all compressed again and re-uploaded. This clearly improved the rendering speed. Also, minor CSS bugs such as layout being distorted at certain width of screen were fixed together.",
      },
      {
        section_title: "Evaluation",
        section_content:
          "The very first project was successfully completed since it met the initial requirements proposed by Mr Han and planned during the ideation and design phases. Also, throughout the project, I was able to pick up extra skills which I had not have. It was a great learning period and was pleased that the feedback from Mr Han and other managers were overall positive. ",
      },
      {
        section_content:
          "However, the skill set was very very limited in my opinion. Especially, implementation of certain dynamic features could only be done with vanilla JavaScript. Some codes in the project were written and they were functioning, I could feel that they were not very clean and optimised. I want to improve this project with better skill stack in the future.",
      },
    ],
  },
  {
    id: 5,
    title: "SINGMATE YUHAK",
    date: "15 October 2023",
    main_image: singmateMainImage,
    subtitle:
      "Website for abroad study agency SINGMATE YUHAK in South Korea was designed and developed. The existing website created by other website agency was redesigned and rebuilt using React.js.",
    sections: [
      {
        section_title: "Ideation",
        section_subtitle: "Background ",
        section_content:
          "SINGMATE YUHAK is agency for studying abroad, based in South Korea. Their main service is providing parents and students in South Korea with information about international schools and universities in Singapore, and assisting the application. ",
      },
      {
        section_content:
          "The opportunity to get connection with SINGMATE YUHAK started as I helped them design promotional banners as a part-time work. At that time, they had already have the website created by web agency in South Korea. However, as I had several conversation with the manager, he pointed out several issues with the use of the website.",
      },
      {
        section_subtitle: "Existing Design",
      },
      {
        section_image: singmateWebsiteLayout,
        section_content:
          "This was the website that had already been created by the web agency. The screenshot shows only portion of main pages and there were around 40+ pages (including the sub-pages). Some of the pages were even incomplete with some blank space and testing images. ",
      },
      {
        section_subtitle: "Project Requirements",
        section_content:
          "So, when I took charge of the project, the requirements requested by SINGMATE were as follow:",
        section_bullets: [
          "There were too many pages and unnecessary contents, they wanted the website to display the key information because the existing contents usually could be delivered during the consultation.",
          "Maintain the sidebar of the website for quick navigation and contact.",
          "Only one common user form submission will be enough - there were 3 different forms.",
          "Each school information is usually given out to parents with brochures so too much details on each school are not needed - simplify each school detail page.",
        ],
      },
      {
        section_title: "Design ",
        section_image: singmateWebsiteLayoutModified,
        section_content:
          "Unlike other projects, there were existing page layouts and designs. So, instead of designing everything from the scratch, they pointed out the components they want to maintain and newly add. Figma was used to design the entire website layout and component image design.",
      },
      {
        section_title: "Development ",
        section_content:
          "The project was developed using React.js and CSS. The main reason for using React.js instead of HTML was that it highly enhances the reusability of the codes. Also, the Single Page Application (SPA) makes the page rendering much faster. Key features of the website and how they were implemented will be described and explained with code snippet in this section.",
      },
      {
        section_subtitle: "File Structure ",
        section_mobile: fileStructure,
        section_content:
          "React.js is component-based architecture, which means development of complex web applications can be done through the composition of small and modular components. So, I created two different directories - components and pages. Reusable components will be managed in the components directory and with them, each page will contain different layouts reusing them. ",
      },
      {
        section_subtitle: "Image Carousel ",
        section_image: obbaSwiperJs,
        section_content:
          "For the Image Carousel in the main page and other sections of the website, Swiper.js was selected. However, unlike the times I developed using HTML, the initialisation was different for React.js. For the project using HTML, initialisation can be done by including the Swiper.js library in the project, either by downloading it or linking to a CDN. Then, you can instantiate a new Swiper instance in JavaScript configuration file. Whereas, for React.js project, a package manager like npm or yarn is used to install Swiper.js. It does not require initialisation and creation of configuration file so it was much easier and fast to use.",
        section_codes: `// Install Swiper.js using npm package manager 
'npm install swiper'

import Swiper from 'swiper';
import 'swiper/css/swiper.css';

const MainBanner = () => {
  return (
    <Swiper
      className="main-banner"
      modules={[Autoplay, Navigation, Pagination]}
      pagination={{ clickable: true }}
      autoplay={{ delay: 2000, disableOnInteraction: false }}
      loop
      speed={1200}
      style={{
        "--swiper-pagination-color": "white",
        "--swiper-pagination-bullet-inactive-color": "gray",
        "--swiper-pagination-bullet-inactive-opacity": "0.8",
      }}
    >
      <SwiperSlide className="main-banner-slide">
        <Link to="/visitform">
          <img
            className="banner-img"
            src="../img/main-banner-2.jpg"
            alt="main-banner-1"
          />
        </Link>
      </SwiperSlide>
      <SwiperSlide className="main-banner-slide">
        <Link to="/visitform">
          <img
            className="banner-img"
            src="../img/main-banner-1.png"
            alt="main-banner-1"
          />
        </Link>
      </SwiperSlide>
    </Swiper>
  );
};

export default MainBanner;`,
      },
      {
        section_content:
          "To compare, the codes for Swiper.js in React.js were personally much simpler and highly manageable and readable for future maintenance. This is because in the projects developed in just HTML and CSS, for every section required image carousel, the lengthy code had to be copied and pasted. Also, for the slight change in the slider, new instance had to be created and this often led to small bugs - quite time consuming. However, the component based Swiper.js could be created once and reused in different sections by simply importing it and with one line of code in between layouts. ",
      },
      {
        section_subtitle: "‘react-router-dom’ for Page Navigation",
        section_content:
          "Since React.js does not have built-in Router, react-router-dom has to be installed. Using react-router-dom, each page can be embedded in App.js just like other components. Each route will be created for specific page with different components.",
        section_codes: `npm i react-router-dom

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'`,
      },
      {
        section_codes: `function App() {
  const [noticeData, setNoticeData] = useState(NoticeData)
  const [interSchoolData, setInterSchoolData] = useState(InterSchoolData)
  const [priUniData, setPriUniData] = useState(PriUniData)
  const [natUniData, setNatUniData] = useState(NatUniData)

  return (
    <Router>
      <ScrollToTop>
        <NavBar />
        <>
          <Routes>
            <Route exact path='/' element={
              <>
                <MainBanner />
                <NoticeComponent noticeData={noticeData}/>
                <SectionBanner />
                <SchoolRecSection />
                <LocationComponent />
                <SmallBanner />
              </>
            }>
            </Route> 

            <Route path='/about' element={<SingmatePage />}/>
            <Route path='/primaryedu' element={<EarlyUhakPage />}/>
            <Route path='/university' element={<UniversityPage />}/>
            <Route path='/langcourse' element={<LanguageCoursePage />}/>
            <Route path='/visitform' element={<VisitPage />}/>
            <Route path='/submitted' element={<SubmittedPage />}/>
            <Route path='/noticeboard' element={<NoticeBoardPage />}/>
            <Route path='/noticeboard/:id' element={<NoticeDetailPage noticeData={noticeData}/>}/>
            <Route path='/interschool-detail/:title' element={<SchoolDetailPage interSchoolData={interSchoolData} />}/>
            <Route path='/priuni-detail/:title' element={<SchoolDetailPage interSchoolData={priUniData} />}/>
            <Route path='/natuni-detail/:title' element={<SchoolDetailPage interSchoolData={natUniData} />}/>
            {/* <Route path='*' element={<Navigate to='/'/>} /> */}
          </Routes>
          <Footer />
        </>
      </ScrollToTop>
    </Router>
  );
}

export default App;`,
      },
      {
        section_content:
          "In the App.js, <Router> was used as parent element to wrap <Routes> and <Route>. To navigate between different screen, in App.js, each specific path will be defined using the ‘path’ prop in the Route component and the component that will be rendered will be specified using the element prop. ",
      },
      {
        section_content:
          "After specifying each route and element to be rendered in the App.js, using <Link> element, different route can be used to set the URL - similar to <a>. ",
        section_codes: `import { Link } from 'react-router-dom'

const NavBar = () => {
    return (
        <>
            <div id='navbar'>
                <div className='navbar container'>
                    <div className='main-logo'>
                        <Link to='/'>
                            <img
                                className='main-logo'
                                src='../img/main-logo.png'
                                alt='sm-logo'
                            />
                        </Link>
                    </div>
                    <div className='nav-menu flex-row'>
                        <ul className='flex-row'>
                            <li>
                                <Link to='/about'>싱메이트 유학</Link>
                            </li>
                            <li>
                                <Link to='/primaryedu'>조기유학</Link>
                            </li>
                            <li>
                                <Link to='/university'>대학교</Link>
                            </li>
                            <li>
                                <Link to='/langcourse'>어학연수</Link>
                            </li>
                            <li>
                                <Link to='/visitform'>방문신청</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="side-quick-menu flex-column">
                <div className="quick-menu-title">
                    <h3>Quick Menu</h3>
                </div>
                <a target='_blank'
                    href='https://pf.kakao.com/_xfxlpNC'>
                    <div className="quick-menu-card flex-column">
                        <div className="quick-menu-img">
                            <img src="../img/icon-kakao.png" alt="kakaoicon" />
                        </div>
                        <div className="quick-menu-btn">
                            <p>카카오톡 채널</p>
                        </div>
                    </div>
                </a>

                <a target='_blank'
                    href='https://m.blog.naver.com/PostList.naver?blogId=singmate'>
                    <div className="quick-menu-card flex-column">
                        <div className="quick-menu-img">
                            <img src="../img/icon-blog.png" alt="kakaoicon" />
                        </div>
                        <div className="quick-menu-btn">
                            <p>싱메이트 블로그</p>
                        </div>
                    </div>
                </a>

                <Link to='/visitform'>
                    <div className="quick-menu-card flex-column">
                        <div className="quick-menu-img">
                            <img src="../img/icon-visit.png" alt="kakaoicon" />
                        </div>
                        <div className="quick-menu-btn">
                            <p>방문상담 예약</p>
                        </div>
                    </div>
                </Link>

                <a href='tel: 025660386'>
                    <div className="quick-menu-card flex-column">
                        <div className="quick-menu-img">
                            <img src="../img/icon-phone.png" alt="kakaoicon" />
                        </div>
                        <div className="quick-menu-btn">
                            <p>전화 상담</p>
                        </div>
                    </div>
                </a>

                <div className="quick-menu-operation flex-column">
                    <div className="operation flex-column">
                        <p>싱메이트 싱가포르</p>
                        <p>평일: 9AM-9PM</p>
                        <p>주말: 9AM-5PM</p>
                    </div>
                    <div className="operation flex-column">
                        <p>싱메이트 강남</p>
                        <p>평일: 9AM-9PM</p>
                        <p>주말: 9AM-5PM</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NavBar`,
      },
      {
        section_content:
          "As seen in the NavBar component above, each menu item is wrapped with <Link> element with ‘to’ prop for specific url path. This will trigger the elements specified in the App.js earlier to render different pages. ",
      },
      {
        section_subtitle: "Fixed Sidebar and its mobile responsive layout",
        section_content:
          "For the quick menu at the side of the home screen, it was requested to maintain the existing the side quick menu but with different design. Also, they wanted the side menu to be bottom menu for mobile version as seen in the screenshots. ",
      },
      {
        section_image: singmateNavMenu,
      },
      {
        section_mobile: singmateMobile,
        section_codes: `<div className="side-quick-menu flex-column">
                <div className="quick-menu-title">
                    <h3>Quick Menu</h3>
                </div>
                <a target='_blank'
                    href='https://pf.kakao.com/_xfxlpNC'>
                    <div className="quick-menu-card flex-column">
                        <div className="quick-menu-img">
                            <img src="../img/icon-kakao.png" alt="kakaoicon" />
                        </div>
                        <div className="quick-menu-btn">
                            <p>카카오톡 채널</p>
                        </div>
                    </div>
                </a>

                <a target='_blank'
                    href='https://m.blog.naver.com/PostList.naver?blogId=singmate'>
                    <div className="quick-menu-card flex-column">
                        <div className="quick-menu-img">
                            <img src="../img/icon-blog.png" alt="kakaoicon" />
                        </div>
                        <div className="quick-menu-btn">
                            <p>싱메이트 블로그</p>
                        </div>
                    </div>
                </a>

                <Link to='/visitform'>
                    <div className="quick-menu-card flex-column">
                        <div className="quick-menu-img">
                            <img src="../img/icon-visit.png" alt="kakaoicon" />
                        </div>
                        <div className="quick-menu-btn">
                            <p>방문상담 예약</p>
                        </div>
                    </div>
                </Link>

                <a href='tel: 025660386'>
                    <div className="quick-menu-card flex-column">
                        <div className="quick-menu-img">
                            <img src="../img/icon-phone.png" alt="kakaoicon" />
                        </div>
                        <div className="quick-menu-btn">
                            <p>전화 상담</p>
                        </div>
                    </div>
                </a>

                <div className="quick-menu-operation flex-column">
                    <div className="operation flex-column">
                        <p>싱메이트 싱가포르</p>
                        <p>평일: 9AM-9PM</p>
                        <p>주말: 9AM-5PM</p>
                    </div>
                    <div className="operation flex-column">
                        <p>싱메이트 강남</p>
                        <p>평일: 9AM-9PM</p>
                        <p>주말: 9AM-5PM</p>
                    </div>
                </div>
            </div>`,
      },
      {
        section_codes: `/* Quickmenu */
.side-quick-menu {
    width: 150px;
    background: #F5F5F5;
    position: fixed;
    top: 0;
    right: 0;
    z-index: 111;
}

.side-quick-menu .quick-menu-title {
    padding: 15px 0 10px 0;
    width: 100%;
    background: var(--point-blue);
}

.side-quick-menu .quick-menu-operation {
    background: var(--point-blue);
    padding: 10px;
    width: 100%;
}

.side-quick-menu .quick-menu-operation .operation {
    margin: 5px 0;
}

.side-quick-menu a {
    width: 100%;
}

.side-quick-menu .quick-menu-operation p {
    color: #fff;
}

.side-quick-menu .quick-menu-title h3 {
    color: #fff;
    text-align: center;
}

.side-quick-menu .quick-menu-card {
    padding: 10px 0;
    margin-top: 10px;
    width: 100%;
    border-bottom: 1px solid #d3d3d3;
}


.quick-menu-card .quick-menu-img {
    width: 50px;
}

.quick-menu-card .quick-menu-btn p {
    margin-top: 20px;
    color: #000;
}
    /* End Quickmenu */


.side-quick-menu {
        flex-direction: row;
        width: 100%;
        height: 100px;
        position: fixed;
        top: unset;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .quick-menu-card {
        border-bottom: none;
    }

    .quick-menu-card .quick-menu-img {
        width: 45px;
    }

    .quick-menu-card .quick-menu-btn p {
        font-size: 14px;
        width: 100%;
        margin-top: 12px;
    }

    .side-quick-menu .quick-menu-title,
    .side-quick-menu .quick-menu-operation {
        display: none;
    }

`,
      },
      {
        section_content:
          "For the mobile layout, the side-quick-menu css was modified so that it will have flex-direction row and reposition itself to the bottom of the screen.",
      },
      {
        section_subtitle: "Tab Component ",
        section_content:
          "It was the first time developing in React.js and usage of React component was not fully utilised. The tab component is clearly showing that because in this project, there were 3 sections requiring the tab components with different tab labels and link. However, the time allowed to complete the project was very limited and I chose to copy and paste, then hardcoded the label and the data iterated. At the time writing this project summary, I regret that the codes could have been better by using React props for for different data passed to one common component to vary the usage. ",
      },
      {
        section_mobile: fileStructure2,
        section_codes: `const TabsComponent = () => {
    const [interSchoolData, setInterSchoolData] = useState(InterSchoolData)
    const [priUniData, setPriUniData] = useState(PriUniData)

    return (
        <Tabs>
            <TabList>
                <Tab>국제학교</Tab>
                <Tab>대학교</Tab>
            </TabList>

            <TabPanel>
                <div className="tab-content-grid container">
                    {interSchoolData.filter((item, idx) => idx < 8).map((school) => (
                        <TabCardComponent school={school} />
                    ))}
                </div>
            </TabPanel>
            <TabPanel>
                <div className="tab-content-grid container">
                    {priUniData.filter((item, idx) => idx < 8).map((school) => (
                        <PriUniTabCardComponent school={school} />
                    ))}
                </div>
            </TabPanel>
        </Tabs>
    )
}

export default TabsComponent`,
      },
      {
        section_codes: `import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { useState } from 'react';
import PriUniData from '../data/PriUniData';
import PriUniTabCardComponent from './shared/PriUniTabCardComponent';
import NatUniData from '../data/NatUniData'
import NatUniTabCardComponent from './shared/NatUniTabCardComponent';

const UniversityTabComponent = () => {
    const [priUniData, setPriUniData] = useState(PriUniData)
    const [natUniData, setNatUniData] = useState(NatUniData)

    return (
        <Tabs>
            <TabList>
                <Tab>사립대학교</Tab>
                <Tab>국립대학교</Tab>
            </TabList>

            <TabPanel>
                <div className="tab-content-grid container">
                    {priUniData.map((school) => (
                        <PriUniTabCardComponent school={school} />
                    ))}
                </div>
            </TabPanel>
            <TabPanel>
                <div className="tab-content-grid container">
                    {natUniData.map((school) => (
                        <NatUniTabCardComponent school={school} />
                    ))}
                </div>
            </TabPanel>
        </Tabs>
    )
}

export default UniversityTabComponent`,
      },
      {
        section_subtitle: "Website Banners ",
        section_image: singmateBanners,
        section_content:
          "Since SINGMATE did not have designer hired during the project, I also had to create the design banner images and resizing of the images used in the website. All the design tasks were done using Figma",
      },
      {
        section_title: "Evaluation ",
        section_content:
          "It was the very first React.js project and it successfully met the initial requirements proposed by the client. For the deployment, ‘Hostinger’ was used like O.BBa Singapore website. It was not full stack project but was a good experience to learn and improve the React.js as well as my designing skills. However, as mentioned earlier in this article, the usage of React component could have been better to maximise the benefits of React.js. ",
      },
    ],
  },
];

export const blogData = [
  {
    id: 1,
    title: "Understanding JavaScript Optional Chaining",
    date: "10 October 2022",
    category: "JavaScript",
    length: "3 MIN READ",
    main_image: jsOptionalMain,
    subtitle:
      "Streamlining Property Access: A Comprehensive Guide to JavaScript Optional Chaining for Safer Navigation Through Nested Objects",
    sections: [
      {
        section_title: "Introduction",
        section_content:
          "JavaScript developers frequently encounter scenarios that require access to the nested properties of objects. However, dealing with nested structures can become difficult if there is a possibility of a ‘null’ or ‘undefined’. In such cases, a new optional chaining feature introduced in ECMAScript 2020 comes to the rescue. This new feature in JavaScript language provides a concise and secure way to navigate nested properties at each level without the need for explicit check.",
      },
      {
        section_title: "What is Optional Chaining?",
        section_image: jsOptional1,
        section_content:
          "Optional Chaining is a JavaScript syntactic feature that simplifies access to properties when dealing with nested objects or arrays. When encountering null or undefined values, it shortens the evaluation, allowing developers to write cleaner codes.",
      },
      {
        section_subtitle: "Basic Example",
        section_content:
          "Let’s break down with a basic example to illustrate why we need optional chaining. Consider a scenario where we have a nested object representing a person’s address:",
        section_codes: `let person = {
  address: {
    city: "Singapore",
	  postalCode: "599328"
  }
};`,
      },
      {
        section_content:
          "Without optional chaining, when we access the ‘city’ property might look like this:",
        section_codes: `let city = person.address && person.address.city;
console.log(city); // Outputs: Singapore`,
      },
      {
        section_content:
          "In this example, logical AND (&&) operator was used to check if person.address exists before accessing ‘city’. This is pretty simple example but as the nesting level increases, it can become very cumbersome.",
      },
      {
        section_subtitle: "Example Using Optional Chaining",
        section_content:
          "Now, let’s rewrite the same example using optional chaining:",
        section_codes: `// With optional chaining
let city = person?.address?.city;
console.log(city); // Outputs: Singpaore`,
      },
      {
        section_content:
          "With optional chaining (?.), the code becomes more concise. While accessing each level of property, if any intermediate property in the chain is null or undefined value, the entire expression evaluates to ‘undefined’. But the key idea is that it will not cause any error.",
      },
      {
        section_subtitle: "Practical Example - Handling Absent Properties",
        section_content:
          "Optional chaining becomes particularly useful when working with dynamically changing data, such as responses from API calls, where the structure may not be guaranteed. ",
        section_codes: `let person = {
  // address is missing
};

// Without optional chaining (may throw an error)
let city = person.address.city;`,
      },
      {
        section_content:
          "For example, when user updated the personal detail in application, it can possibly be left blank for some reasons. In such case, without optional chaining, trying to access ‘city’ would throw an error because ‘person.address’ is undefined. ",
        section_codes: `// With optional chaining
let city = person?.address?.city;
console.log(city); // Outputs: undefined`,
      },
      {
        section_content:
          "Optional chaining gracefully handles the absence of the address property and assigns undefined to ‘city’",
      },
      {
        section_content:
          "Optional chaining is not limited to only property accessing. It can be also used with function calls. Consider a case where a function is missing.",
        section_codes: `let myObject = {
  myFunction: () => "Hello, World!"
};

// Without optional chaining
let result = myObject.myFunction && myObject.myFunction();
console.log(result); // Outputs: Hello, World!`,
      },
      {
        section_content:
          "It can be simplified with optional chaining as follow:",
        section_codes: `// With optional chaining
let result = myObject?.myFunction?.();
console.log(result); // Outputs: Hello, World!`,
      },
      {
        section_content:
          "As seen, optional chaining gives a more concise and readable code as a solution.",
      },
      {
        section_title: "Conclusion",
        section_content:
          "Optional chaining is a valuable addition to the JavaScript language. It not only simplifies the process of working with nested structures and dynamic data but also increases code readability and reduces the need for explicit checks at each level. From the ECMAScript 2020 and optional chaining introduced then, it is now becoming as a standard tool for JavaScript developers.",
      },
      {
        section_content:
          "In summary, whether you are dealing with complex objects, API responses or function calls, optional chaining allows you to navigate potentially undefined properties or null properties more cleanly and securely.",
      },
    ],
  },
  {
    id: 2,
    title: "Mastering Navigation in React Native with React Navigation",
    date: "21 June 2022",
    category: "React Native",
    length: "3 MIN READ",
    main_image: rnNavigationMain,
    subtitle:
      "Navigating the Seas of React Native: A Comprehensive Guide to React Navigation and Bottom Tabs",
    sections: [
      {
        section_title: "Introduction",
        section_content:
          "React Native has gained immense popularity for building cross-platform mobile applications. Navigation is a crucial aspect of building mobile applications. It ensures the flow and organisation of screens and views within a mobile application. Efficient navigation is key to seamless user experience. ",
      },
      {
        section_content:
          "There are several navigation solutions in React Native but we will be exploring the popular navigation library, ‘React Navigation’. From installation and configuration, essential Stack and Bottom Tabs in React Navigation will be explained in this post.",
      },
      {
        section_subtitle: "React Navigation: Navigating Your Way",
        section_content: "Installation:",
      },
      {
        section_content:
          "To get started, we need to install React Navigation in your project",
        section_codes: `npm install @react-navigation/native @react-navigation/stack`,
      },
      {
        section_subtitle: "Stack Navigator",
        section_content:
          "React Navigation involves a stack-based navigation system. The Stack Navigator from ‘@react-navigation/stack’ allows you push and pop screens within the navigation stack.",
        section_codes: `import { createStackNavigator } from '@react-navigation/stack';

const Stack = createStackNavigator();

const MyStack = () => {
  return (
    <Stack.Navigator>
      <Stack.Screen name="Home" component={HomeScreen} />
      <Stack.Screen name="Details" component={DetailsScreen} />
    </Stack.Navigator>
  );
}`,
      },
      {
        section_subtitle: "Navigation Container",
        section_content:
          "To provide navigation context to the application, you have to wrap your entire application with ‘NavigationContainer’.",
        section_codes: `import { NavigationContainer } from '@react-navigation/native';

const App = () => {
  return (
    <NavigationContainer>
      <MyStack />
    </NavigationContainer>
  );
}`,
      },
      {
        section_subtitle: "Navigate Between Screens",
        section_content:
          "To navigate between screens in the stack, navigate() of the prop ‘navigation’ can be used.",
        section_codes: `const HomeScreen = ({ navigation }) => {
  return (
    <View>
      <Text>Home Screen</Text>
      <Button
        title="Go to Details"
        onPress={() => navigation.navigate('Details')}
      />
    </View>
  );
}`,
      },
      {
        section_subtitle: "Bottom Tabs: Navigating at Your Fingertips",
        section_content:
          "Another common navigation type is bottom tabs. It is popular navigation pattern that places tabs at the bottom of the screen, allowing users to easily switch between different sections of an application. ‘React Navigation’ provides the ‘createBottomTabNavigator’ function for bottom tab implementation.",
      },
      {
        section_content: "Installation:",
      },
      {
        section_subtitle: "Install the necessary package",
        section_codes: `npm install @react-navigation/bottom-tabs`,
      },
      {
        section_content:
          "You can create bottom tabs in a way similar to creating Stack.",
      },
      {
        section_content: "Creating Screens for bottom navigation:",
        section_codes: `const HomeScreen = () => {
  return (
    <View>
      <Text>Home Screen</Text>
    </View>
  );
}

const ProfileScreen = () => {
  return (
    <View>
      <Text>Profile Screen</Text>
    </View>
  );
}`,
      },
      {
        section_subtitle: "Create Bottom Tab Navigator",
      },
      {
        section_content:
          "Use createBottomTabNavigator to create a bottom tab navigator:",
        section_codes: `import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';

const BottomTab = createBottomTabNavigator();

function App() {
  return (
    <BottomTab.Navigator>
      <BottomTab.Screen name="Home" component={HomeScreen} />
      <BottomTab.Screen name="Profile" component={ProfileScreen} />
    </BottomTab.Navigator>
  );
}`,
      },
      {
        section_subtitle: "Customisation of Tabs",
        section_content:
          "Commonly, bottom tab menu contains icon and label. You can also customise them on your needs as follow:",
        section_codes: `<BottomTab.Navigator>
  <BottomTab.Screen
    name="Home"
    component={HomeScreen}
    options={{
      tabBarLabel: 'Home',
			tabBarIcon: ({ color, size }) => (
            <FeatherIcon name="home" size={size} color={color} />
          ),
    }}
  />
  <BottomTab.Screen
    name="Profile"
    component={ProfileScreen}
    options={{
      tabBarLabel: 'Profile',
			tabBarIcon: ({ color, size }) => (
            <FeatherIcon name="settings" size={size} color={color} />
          ),
    }}
  />
</BottomTab.Navigator>`,
      },
      {
        section_title: "Conclusion",
        section_content:
          "Mastering navigation is crucial for building user-centred mobile applications. React Navigation Stack and Bottom Tabs provide a way to create a seamless and enhanced user experience. Regardless of the size of the application you are building, these concepts will guide you in the right direction.",
      },
      {
        section_content: "Happy Coding!",
      },
      {},
      {},
      {},
      {},
    ],
  },
  {
    id: 3,
    title: "Demystifying React Hooks: A Beginner’s Guide",
    date: "22 July 2021",
    category: "React",
    length: "6 MIN READ",
    main_image: reacthookMain,
    subtitle:
      "Unlocking the Power of React Hooks: A Comprehensive Introduction for Beginners",
    sections: [
      {
        section_title: "Introduction",
        section_content:
          "Welcome! If you have recently embarked on your journey as a React developer, you might have already come across the term “React hooks”. In this beginner-friendly post, the mystery of React hooks will be unravelled. 3 essential React hooks will be explored and I promise they will empower you to take your React skills to the next level.",
      },
      {
        section_subtitle: "Understanding the Basics",
        section_content:
          "Before we dive into React Hooks, it is important to understand the fundamental concepts of React.js. React.js is a JavaScript library for building user interfaces. The key idea of React.js is that it revolves around the concept of components. To make it simple, components are building blocks of a React application - just like lego block we played with. It encapsulates both the user interface and the logic behind it.",
      },
      {
        section_content:
          "Traditionally, React components could be classified into two types:",
        section_bullets: ["Class components", "Functional components"],
      },
      {
        section_content:
          "Class components had access to features like state and lifecycle methods but functional components were considered stateless. From the React version 16.8, it transformed the landscape. Functional components now can harness the power of state and other React features as strong as class components have done.",
      },
      {
        section_subtitle: "The Power of React Hooks",
        section_content:
          "So what are React Hooks? React Hooks are functions that provide a way to use React state and lifecycle features in functional components. They enhance the reusability of codes and logic structure within components. Are you performing side effects or having issue with performance optimisation? React Hooks got you covered!",
      },
      {
        section_content:
          "In this post, 3 essential React hooks - useState, useEffect, and useContext will be covered with easy-to-understand explanation and example codes.",
      },
      {
        section_subtitle: "1. useState: Managing Component State",
        section_codes: `import React, { useState } from 'react';

const Counter = () => {
  const [count, setCount] = useState(0);

  return (
    <div>
      <p>Count: {count}</p>
      <button onClick={() => setCount(count + 1)}>Increment</button>
    </div>
  );
}`,
      },
      {
        section_content:
          "The ‘useState’ hook allows functional components to manage local state. State is a way for a component to keep track of information that can dynamically change. It allows React components to render dynamically based on the current state and to update the state in response to different scenarios such as user actions, events or other asynchronous behaviours.",
      },
      {
        section_content:
          "In the example above, ‘useState’ hook is used to declare a state variable ‘count’ with an initial value of ‘0’. The set function ‘setCount’ allows us to update the value of ‘count’. When button is pressed, React will re-render the component with the updated count. ",
      },
      {
        section_content:
          "React state should not be modified directly. Instead, we can make use of setState function provided by ‘useState’ - setCount is the example.",
      },
      {
        section_codes: `const [name, setName] = useState('John');
const [age, setAge] = useState(25);`,
      },
      {
        section_content:
          "You can also use ‘useState’ multiple times in a component to manage different pieces of state independently.",
      },
      {
        section_subtitle: "2. useEffect: Performing Side Effects",
        section_content:
          "The ‘useEffect’ hook provides a way to perform side effects in functional components. Side effects can be defined as operations or tasks that can occur outside of the scope in the normal rendering process. It can be data fetching, subscriptions, DOM manipulations or setting up and cleaning up resources within a component.",
      },
      {
        section_content:
          "In React, rendering is synchronous process. Tasks like fetching data from an API are asynchronous. So, useEffect hook is needed to ensure the asynchronous behaviour for your components without the disruption of the normal rendering process.",
        section_codes: `import React, { useEffect, useState } from 'react';

function DataFetcher() {
  const [data, setData] = useState(null);

  useEffect(() => {
    // Asynchronous operation 
    fetchData().then((result) => setData(result));
  }, []); // Dependency array is empty, so the effect runs once after the initial render

  return <p>Data: {data}</p>;
}`,
      },
      {
        section_content:
          "In this example, ‘useEffect’ is used for fetching data asynchronously, and the returned result is stored in the component’s state - created with useState hook!",
      },
      {
        section_content:
          "Another key feature of ‘useEffect’ hooks is that it enables you to replicate the behaviour of the lifecycle methods from class components - ‘componentDidMount’, ‘componentDidUpdate’, and ‘componentWillUnmound’. ‘useEffect’ hook allows you to hook into different phases of a component’s life. ",
        section_codes: `import React, { useEffect } from 'react';

function LifecycleDemo() {
  useEffect(() => {
    // Runs after the initial render (componentDidMount)
    console.log('Component mounted');

    // Runs before each subsequent re-render (componentDidUpdate)
    return () => {
      console.log('Component will unmount');
      // Cleanup logic goes here
    };
  }, []); // Empty dependency array means the effect runs once after the initial render

  return <p>Component with lifecycle</p>;
}`,
      },
      {
        section_content:
          "Also, ‘useEffect’ hook requires the dependency array and it is a crucial concept. It specifies the values from the component’s scope that the effect depends on. When any dependencies set in the dependency array change, the effect is re-executed. ",
        section_codes: `import React, { useEffect, useState } from 'react';

function DependentEffect({ userId }) {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    // Fetch user data when userId changes
    fetchUserData(userId).then((result) => setUserData(result));
  }, [userId]); // Dependency array includes userId

  return <p>User Data: {userData}</p>;
}`,
      },
      {
        section_content:
          "The effect re-runs whenever the ‘userId’ prop changes. It can be really useful in the scenario when there are new user data coming in and it has to ensure the re-render of a component with the new data. ",
      },
      {
        section_subtitle: "3. useContext: Accessing Context Values",
        section_content:
          "‘useContext’ hook simplifies the process of consuming values from a React context within functional components. Context in React is a way to share values among different components. Examples scenarios in application can be sharing themes, authentication status or language preferences. Across a component tree, values can be shared without prop drilling down to every level of the tree. Context is essential especially when you have data that many components have to access to. ",
      },
      {
        section_content: "Context can be basically created as follow:",
        section_codes: `// context.js
import React, { createContext } from 'react';

export const Context = createContext('Default Value')`,
      },
      {
        section_content:
          "We can create a context using ‘createContext’ from ‘react’.",
        section_codes: `import { Context } from './context';

function Main() {
  const value = 'My Context Value';
  return (
    <Context.Provider value={value}>
      <MyComponent />
    </Context.Provider>
  );
}`,
      },
      {
        section_content:
          "Then, we wrap the component using ‘Provider’ component. By wrapping the component tree, the components within the ‘Provider’ component will be able to access the context value.",
        section_codes: `import { useContext } from 'react';
import { Context } from './context';

function MyComponent() {
  const value = useContext(Context);

  return <span>{value}</span>;
}`,
      },
      {
        section_content:
          "Within the components of the tree wrapped by ‘Provider’ component, we can now access and use the value. ‘useContext’ is called with the context object ‘Context’ and it returns the current context value.",
      },
      {
        section_content:
          "With context and ‘useContext’, you can avoid prop drilling (passing props through multiple levels of components), making your codes more maintainable. ",
      },
      {
        section_title: "Conclusion",
        section_content:
          "In conclusion, as you start your React journey, understanding and harnessing the power of React hooks will significantly enhance your skill for dynamic and responsive UI creation. ‘useState’ hook is powerful for effortless state management, ‘useEffect’ hook handles side effects and component lifecycle seamlessly, and ‘useContext’ simplifies sharing of values among different component across your application. Equipped with these fundamental hooks, you are on the right track to building robust and maintainable React applications.",
      },
      {
        section_content: "Happy Coding!",
      },
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {},
    ],
  },
  {
    id: 4,
    title: "Dynamic Lists in React Native: FlatList vs. ScrollView",
    date: "10 March 2021",
    category: "Redux",
    length: "5 MIN READ",
    main_image: reduxToolkitMain,
    subtitle: "A Beginner's Guide to Efficient Data Rendering and Pagination",
    sections: [
      {
        section_title: "Introduction",
        section_subtitle: "Redux Toolkit vs Redux",
        section_content:
          "Redux Toolkit was introduced to address some common pain points and boilerplate associated with using traditional Redux. Redux is an open-source JavaScript library for managing the state of application in a predictable way. It is commonly used with React, but it can be integrated with any JavaScript framework or library.",
      },
      {
        section_content:
          "To understand better why Redux Toolkit came into place, it is better to know the some key differences between Redux Toolkit and Redux. ",
        section_bullets: [
          "Reduction of Boilerplate - managing actions, action creators, and reducers involves a significant amount of boilerplate codes with Redux but ‘createSlice’ function in Redux Toolkit combines the definition of actions and reducers into a single file. ",
          "Simplified Immutable Updates - Immutably updating state can be error-prone and it requires to create new objects or arrays to represent updated state. With Redux Toolkit, it automatically generates immutable updates behind the scenes.",
          "Async Action Handling - With Redux, managing asynchronous actions involve creation of multiple action types and dispatching actions at different stages of the asynchronous process but Redux Toolkit provides ‘createAsyncThunk’ to streamline the asynchronous logic. This reduces the need for manually defining action types and dispatching multiple actions.",
          "Simplified Store Configuration - For Redux, configuring the Redux store requires combining reducers, middleware and store but with Redux Toolkit, ‘configureStore’ function simplifies store configuration by handling common setup tasks. ",
        ],
      },
      {
        section_content:
          "Up to this point of reading, if you have not much experience with both Redux and Redux Toolkit, you can feel very confused. But do not worry, this post will guide you the basics of Redux Toolkit with practical examples.",
      },
      {
        section_subtitle: "Basic Steps to Use Redux Toolkit",
        section_content:
          "So, remember that Redux Toolkit is a package that helps simplify the process of managing state in a Redux-based application. It provides a set of utilities and abstractions to reduce boilerplate code and make it easier to work with Redux. I recommend you to get used to using Redux Toolkit first and search for Redux later. This will make you think ‘why do I need all these codes?’ but at the same time, will give you better understanding of how Redux works. ",
      },

      {
        section_subtitle: "Step 1: Installation",
        section_codes: `npm install @reduxjs/toolkit react-redux`,
      },
      {
        section_subtitle: "Step 2: Create a Slice",
        section_content:
          "A slice is a piece of your Redux store’s state and the corresponding set of actions that can be performed on that state. ‘createSlice’ function from Redux Toolkit is used to create a slice.",
        section_codes: `import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    // Define your initial state he
  },
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
  },
});

export const { setUserInfo } = userSlice.actions;
export default userSlice.reducer;`,
      },

      {
        section_subtitle: "Step 3: Create a Redux Store",
        section_content:
          "We have a slice. Now we need a store to contain all these slices - you can create multiple slices based on your needs for application. ‘configureStore’ function from Redux Toolkit is used to create Redux Store.",
        section_codes: `import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
    // Add other reducers as needed
  },
});

export default store;`,
      },
      {
        section_subtitle: "Step 4: Integrate Redux in Your Application",
        section_content:
          "React Native project was used for this section. In your main component file (e.g. ‘App.js’), you wrap your entire application with ‘Provider’ component from ‘react-redux’ and pass the Redux store you created earlier.",
        section_codes: `import React from 'react';
import { Provider } from 'react-redux';
import store from './src/redux/store';
import AppNavigator from './src/navigation/AppNavigator';

const App = () => {
  return (
    <Provider store={store}>
      <AppNavigator />
    </Provider>
  );
};

export default App;`,
      },
      {
        section_title: "Practical Usage Case of Redux Toolkit",
        section_content:
          "Okay, now we learned how to do the basic configuration for Redux Toolkit. Let’s talk about practical usage of Redux Toolkit. One common cases are managing user authentication state.",
      },
      {
        section_subtitle: "Managing User Authentication State",
        section_content:
          "Personally I used Redux Toolkit when I worked on React Native projects with Firebase user authentication. User authentication involves asynchronous actions such as making API requests to log in or log out a user. It is not strictly required to use Redux Toolkit for this purpose but it simplifies the asynchronous logic across the entire application.",
      },

      {
        section_content: "User Slice:",
        section_codes: `const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isAuthenticated: fals
  },
  reducers: {
    login: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;`,
      },
      {
        section_content:
          "You can create a slice for user authentication state as above. In the initialState, there are two states - isAuthenticated and user. They will contain the boolean authentication status and user data fetched respectively.",
      },
      {
        section_content: "Usage in Component:",
        section_codes: `import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login, logout } from '../redux/slices/authSlice';

const MyComponent = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector((state) => state.auth.user);

  const handleLogin = () => {
    // Simulating a login action
    dispatch(login({ id: 1, username: 'john_doe' }));
  };

  const handleLogout = () => {
    // Simulating a logout action
    dispatch(logout());
  };

  return (
    <div>
      {isAuthenticated ? (
        <div>
          <p>Welcome, {user.username}!</p>
          <button onClick={handleLogout}>Logout</button>
        </div>
      ) : (
        <div>
          <p>Please log in</p>
          <button onClick={handleLogin}>Login</button>
        </div>
      )}
    </div>
  );
};

export default MyComponent;`,
      },
      {
        section_content:
          "To get access to the state in a slice, ‘useSelector’ is used and to dispatch actions on states, ‘useDispatch’ is used. In the example code, assuming user data only contains username, for authenticated user, it renders greeting with user’s name.",
      },
      {
        section_content:
          "The two buttons handle login and logout. The actions defined in the slice can be dispatched as seen in the example. If needed, in this case for login, it passes payload to the action and stored in the user state in the slice.",
      },
      {
        section_title: "Conclusion",
        section_content:
          "In this introductory exploration, we touched the fundamental concepts of Redux Toolkit and its role in managing state in a predictable way. It is only scratching the surface of Redux but I wanted to post it as a starting point for future posts. In the future posts, we will dive deeper into specific use cases such as managing user authentication state and handling  asynchronous operations with actual screenshots of application running.",
      },
      {
        section_content:
          "In the upcoming posts, we will tackle more complex scenarios. Thank you for your visit and stay tuned for more.",
      },
      {
        section_content: "Happy Coding!",
      },
    ],
  },
  {
    id: 5,
    title: "Dynamic Lists in React Native: FlatList vs. ScrollView",
    date: "17 January 2021",
    category: "React Native",
    length: "5 MIN READ",
    main_image: rnFlatlistMain,
    subtitle: "A Beginner's Guide to Efficient Data Rendering and Pagination",
    sections: [
      {
        section_title: "Introduction",
        section_content:
          "React Native provides two powerful components, ‘FlatList’ and ‘ScrollView’, for handling lists of data. Both are used to render a scrollable list of components, but they have different usage and performance implications. In this post, we will explore the differences between these two components. Also, the reason why ‘FlatList’ is the preferred choice for dynamic data rendering, especially when dealing with large datasets and implementing pagination, will be discussed.",
      },
      {
        section_subtitle: "ScrollView",
        section_content:
          "Before we jump into the ‘FlatList’, we will be exploring the ‘ScrollView’.",
      },
      {
        section_content:
          "‘ScrollView’ is a generic scrolling container that is commonly used in React Native development. It wraps a list of components and is a simple way to make components scrollable. However, considering the efficiency, it may not be the best choice for long lists of components. This is because ‘ScrollView’ renders all of its children at once regardless of the size of components that can be actually seen by users. This frequently leads to performance issues especially when dealing with a large amount of data. It consumes more memory and ends up slowing down the entire application. ",
      },
      {
        section_subtitle: "Example usage of ‘ScrollView’",
        section_codes: `import React from 'react';
import { ScrollView, Text } from 'react-native';

const MyScrollView = () => {
  return (
    <ScrollView>
      <Text>Item 1</Text>
      <Text>Item 2</Text>
      <Text>Item 3</Text>
      {/* ...more items... */}
    </ScrollView>
  );
};

export default MyScrollView;`,
      },

      {
        section_content:
          "It is suitable for a small number of items or short lists.",
      },
      {
        section_subtitle: "FlatList",
        section_content:
          "Then, for rendering of lists of components, we have the second option - ‘FlatList’.",
      },
      {
        section_content:
          "‘FlatList’ is a more optimised component for rendering long lists of data. The key difference between ‘ScrollView’ and ‘FlatList’ is that ‘FlatList’ only render the items that are currently visible on the screen. It recycles and reuses components as user scrolls. Instead of rendering all of the children components at once, the LazyLoading feature of ‘FlatList’ makes it more memory-efficient and faster for larger datasets. ",
      },
      {
        section_subtitle: "Example Usage of FlatList",
        section_codes: `import React from 'react';
import { FlatList, Text } from 'react-native';

const MyFlatList = () => {
  const data = [
    { key: '1', text: 'Item 1' },
    { key: '2', text: 'Item 2' },
    { key: '3', text: 'Item 3' },
    // ...more items...
  ];

  return (
    <FlatList
      data={data}
      renderItem={({ item }) => <Text>{item.text}</Text>}
    />
  );
};

export default MyFlatList;`,
      },
      {
        section_content:
          "Specifically designed for efficient rendering long lists of data, ‘FlatList’ component is the better choice over ‘ScrollView’ when dealing with large datasets and considering the performance of application.",
      },
      {
        section_content:
          "So, using ‘FlatList’ over ‘ScrollView’ depends on the usage scenario. However, in many cases such as involving long lists, dynamic data fetching, and pagination, ‘FlatList’ is chosen instead of ‘ScrollView’.",
      },
      {
        section_subtitle:
          "Example of Using FlatList for fetching data from an API and Paginate it",
        section_content:
          "Now, let’s talk about ‘pagination’. Imagine you have so much datasets that it cannot fit on one screen at once. With ‘FlatList’, you can seamlessly load more data as user scrolls down. The key idea of pagination is that it only fetches more when needed. This efficiently saves the API calls and also enhances the application performance. ",
        section_codes: `import React, { useState, useEffect } from 'react';
import { FlatList, Text, View, Button, ActivityIndicator } from 'react-native';

const MyFlatListWithApi = () => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(\`https://api.example.com/data?page=\${page}\`);
      const newData = await response.json();
      setData((prevData) => [...prevData, ...newData]);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  const renderFooter = () => {
    return isLoading ? <ActivityIndicator size="large" color="#0000ff" /> : null;
  };

  return (
    <FlatList
      data={data}
      renderItem={({ item }) => <Text>{item.text}</Text>}
      keyExtractor={(item) => item.id.toString()}
      onEndReached={() => setPage((prevPage) => prevPage + 1)}
      onEndReachedThreshold={0.1}
      ListFooterComponent={renderFooter}
    />
  );
};

export default MyFlatListWithApi;`,
      },
      {
        section_content:
          "In this example, the ‘fetchData’ function is used for fetching data from the API based on the current page value. Then, the ‘FlatList’ component is used to render the data with pagination. We have to look at the two props used in the ‘FlatList’ - onEndReached and onEndReachedThreshold. ‘onEndReached’ is a callback that gets triggered when user reaches the end of the list. This allow you to fetch more data. ‘onEndReachedThreshold’ sets the percentage of the list height that should be reached to trigger the ‘onEndReached’ callback. So, two props work as a set. ‘ListFooterComponent’ is another commonly used prop for rendering footer component while fetching and rendering more data as user scrolls down. While fetching more data to load, you can add ‘ActivityIndicator’ to notice user that the application is loading more data for user. This is another approach for better user experience.",
      },
      {
        section_title: "Conclusion",
        section_content:
          "We have uncovered the secrets behind the two fundamental React Native components: ‘FlatList’ and ‘ScrollView’. Both play a crucial role in ensuring your mobile applications are visually appealing and performant.",
      },
      {
        section_subtitle: "Recap of Key Takeaways",
        section_content: "ScrollView:",
        section_bullets: [
          "A versatile scrolling container - suitable for small lists or a limited number of items.",
          "Renders all items at once - can lead to performance issues when dealing with large datasets.",
        ],
      },
      {
        section_content: "FlatList:",
        section_bullets: [
          "Specifically designed for efficient rendering long lists of data.",
          "Renders only the items that are currently visible on the screen - optimises application performance for scalable datasets.",
        ],
      },
      {
        section_content:
          "I believe the knowledge gained through this post here will be invaluable regardless of the size of mobile application you are building. mastering React Native is an ongoing journey and each discovery brings us one step closer to the level of professional mobile developer. I hope this post helps you in your  React Native journey. Thank you and see you soon.",
      },
      {
        section_content: "Happy Coding!",
      },
    ],
  },
];
